/** P0: Catalog form wizards (package / tour / accommodation / service) — ko/en/vi/ru */

const common = {
  draft: ['임시저장', 'Save draft', 'Lưu nháp', 'Черновик'],
  prev: ['이전', 'Previous', 'Trước', 'Назад'],
  next: ['다음 →', 'Next →', 'Tiếp →', 'Далее →'],
  publish: ['게시하기 ✓', 'Publish ✓', 'Đăng ✓', 'Опубликовать ✓'],
  planLockDefault: [
    '유료 플랜에서 사용할 수 있어요',
    'Available on paid plans',
    'Dùng được trên gói trả phí',
    'Доступно на платных планах',
  ],
  planLockCta: [
    '유료 플랜 알아보기',
    'View paid plans',
    'Xem gói trả phí',
    'Платные планы',
  ],
  toastRequired: [
    '필수 항목을 입력해 주세요',
    'Please fill in required fields',
    'Vui lòng nhập các mục bắt buộc',
    'Заполните обязательные поля',
  ],
  toastDraftSaved: ['임시저장됐어요', 'Draft saved', 'Đã lưu nháp', 'Черновик сохранён'],
  toastSaveFailed: ['저장 실패', 'Save failed', 'Lưu thất bại', 'Не удалось сохранить'],
  toastPublishFailed: ['게시 실패', 'Publish failed', 'Đăng thất bại', 'Не удалось опубликовать'],
  langKo: ['한국어', 'Korean', 'Tiếng Hàn', 'Корейский'],
  langEn: ['영어', 'English', 'Tiếng Anh', 'Английский'],
  langVi: ['베트남어', 'Vietnamese', 'Tiếng Việt', 'Вьетнамский'],
  langRu: ['러시아어', 'Russian', 'Tiếng Nga', 'Русский'],
  langJa: ['일본어', 'Japanese', 'Tiếng Nhật', 'Японский'],
  langZh: ['중국어', 'Chinese', 'Tiếng Trung', 'Китайский'],
  cancelFree24hFull: [
    '24시간 전 전액환불',
    'Full refund 24h before',
    'Hoàn full trước 24 giờ',
    'Полный возврат за 24 ч',
  ],
  cancelNonRefundable: ['환불불가', 'Non-refundable', 'Không hoàn tiền', 'Без возврата'],
  cancelCustom: ['직접입력', 'Custom', 'Tự nhập', 'Свой вариант'],
  duration30m: ['30분', '30 min', '30 phút', '30 мин'],
  duration1h: ['1시간', '1 hour', '1 giờ', '1 час'],
  duration2h: ['2시간', '2 hours', '2 giờ', '2 часа'],
  durationHalfDay: ['반일', 'Half day', 'Nửa ngày', 'Полдня'],
  durationFullDay: ['종일', 'Full day', 'Cả ngày', 'Велый день'],
};

const pkgSteps = {
  basic: ['기본', 'Basic', 'Cơ bản', 'Основное'],
  services: ['서비스', 'Services', 'Dịch vụ', 'Услуги'],
  itinerary: ['일정', 'Itinerary', 'Lịch trình', 'Маршрут'],
  terms: ['약관', 'Terms', 'Điều khoản', 'Условия'],
  pricing: ['가격', 'Pricing', 'Giá', 'Цены'],
  finish: ['마무리', 'Finish', 'Hoàn tất', 'Финиш'],
};

const pkgOptions = {
  nightN: ['{n}박', '{n} night(s)', '{n} đêm', '{n} ноч.'],
  night10Plus: ['10박 이상', '10+ nights', 'Từ 10 đêm', '10+ ночей'],
  dayN: ['{n}일', '{n} day(s)', '{n} ngày', '{n} дн.'],
  day15Plus: ['15일 이상', '15+ days', 'Từ 15 ngày', '15+ дней'],
  departDaily: ['매일', 'Daily', 'Hàng ngày', 'Ежедневно'],
  departMwf: ['월수금', 'Mon/Wed/Fri', 'T2/T4/T6', 'Пн/Ср/Пт'],
  departTts: ['화목토', 'Tue/Thu/Sat', 'T3/T5/T7', 'Вт/Чт/Сб'],
  departSpecific: ['특정날짜', 'Specific dates', 'Ngày cụ thể', 'Конкретные даты'],
  departCustom: ['요일직접선택', 'Pick weekdays', 'Chọn thứ', 'Выбрать дни'],
  weekdaySun: ['일', 'Sun', 'CN', 'Вс'],
  weekdayMon: ['월', 'Mon', 'T2', 'Пн'],
  weekdayTue: ['화', 'Tue', 'T3', 'Вт'],
  weekdayWed: ['수', 'Wed', 'T4', 'Ср'],
  weekdayThu: ['목', 'Thu', 'T5', 'Чт'],
  weekdayFri: ['금', 'Fri', 'T6', 'Пт'],
  weekdaySat: ['토', 'Sat', 'T7', 'Сб'],
  deadline24h: ['출발 24시간 전', '24h before departure', 'Trước khởi hành 24 giờ', 'За 24 ч до выезда'],
  deadline48h: ['출발 48시간 전', '48h before departure', 'Trước khởi hành 48 giờ', 'За 48 ч до выезда'],
  deadline7d: ['출발 7일 전', '7 days before departure', 'Trước khởi hành 7 ngày', 'За 7 дней до выезда'],
  bookingInstant: ['즉시예약', 'Instant book', 'Đặt ngay', 'Мгновенно'],
  bookingInquiry: ['예약문의', 'Inquiry', 'Hỏi đặt', 'Запрос'],
  bookingApproval24h: ['24시간 승인', '24h approval', 'Duyệt trong 24 giờ', 'Одобрение 24 ч'],
  cancelFree24h: ['24시간 전 무료', 'Free cancel 24h before', 'Hủy miễn phí trước 24 giờ', 'Бесплатная отмена за 24 ч'],
  cancelFree48h: ['48시간 전 무료', 'Free cancel 48h before', 'Hủy miễn phí trước 48 giờ', 'Бесплатная отмена за 48 ч'],
  cancelFree7d: ['7일 전 무료', 'Free cancel 7 days before', 'Hủy miễn phí trước 7 ngày', 'Бесплатная отмена за 7 дн.'],
  cancelNonRefundable: ['환불불가', 'Non-refundable', 'Không hoàn tiền', 'Без возврата'],
  difficultyEasy: ['쉬움', 'Easy', 'Dễ', 'Лёгкий'],
  difficultyNormal: ['보통', 'Normal', 'Vừa', 'Обычный'],
  difficultyActive: ['액티브', 'Active', 'Năng động', 'Активный'],
  difficultyHard: ['하드', 'Hard', 'Khó', 'Сложный'],
  audienceFamily: ['가족추천', 'Family', 'Gia đình', 'Семья'],
  audienceCouple: ['커플', 'Couples', 'Cặp đôi', 'Пары'],
  audienceSolo: ['혼자여행', 'Solo', 'Một mình', 'Соло'],
  audienceKids: ['아이동반', 'Kids welcome', 'Có trẻ em', 'С детьми'],
  audienceParents: ['부모님', 'Parents', 'Bố mẹ', 'Родители'],
  audienceSenior: ['노약자가능', 'Seniors OK', 'Người cao tuổi OK', 'Для пожилых'],
  guideKrGuide: ['한국인가이드', 'Korean guide', 'HDV Hàn', 'Корейский гид'],
  guideKrLocal: ['한국어능통현지인', 'Local fluent in Korean', 'Người địa phương giỏi tiếng Hàn', 'Местный с корейским'],
  guideKrBasic: ['기초한국어', 'Basic Korean', 'Tiếng Hàn cơ bản', 'Базовый корейский'],
  guideEn: ['영어', 'English', 'Tiếng Anh', 'Английский'],
  guideLocal: ['현지어', 'Local language', 'Ngôn ngữ địa phương', 'Местный язык'],
  serviceMeal: ['식사', 'Meals', 'Bữa ăn', 'Питание'],
  servicePickup: ['픽업', 'Pickup', 'Đón', 'Трансфер'],
  serviceGuide: ['가이드', 'Guide', 'Hướng dẫn', 'Гид'],
  serviceHotel: ['숙소', 'Hotel', 'Khách sạn', 'Отель'],
  serviceFlight: ['항공', 'Flight', 'Máy bay', 'Авиа'],
  serviceAdmission: ['입장료', 'Admission', 'Vé vào', 'Вход'],
  serviceInsurance: ['보험', 'Insurance', 'Bảo hiểm', 'Страховка'],
  serviceWater: ['생수', 'Water', 'Nước', 'Вода'],
  hotel3star: ['3성', '3-star', '3 sao', '3*'],
  hotel4star: ['4성', '4-star', '4 sao', '4*'],
  hotel5star: ['5성', '5-star', '5 sao', '5*'],
  hotelResort: ['리조트', 'Resort', 'Resort', 'Курорт'],
  hotelPoolvilla: ['풀빌라', 'Pool villa', 'Villa hồ bơi', 'Вилла с бассейном'],
  hotelGuesthouse: ['게스트하우스', 'Guesthouse', 'Nhà nghỉ', 'Гостевой дом'],
  hotelKoreanStay: ['한인민박', 'Korean homestay', 'Homestay Hàn', 'Корейский хоумстей'],
  hotelNone: ['미포함', 'Not included', 'Không gồm', 'Не включено'],
  transportBus: ['버스', 'Bus', 'Xe buýt', 'Автобус'],
  transportBoat: ['보트', 'Boat', 'Thuyền', 'Лодка'],
  transportWalk: ['도보', 'Walk', 'Đi bộ', 'Пешком'],
  transportCar: ['차량', 'Car', 'Xe', 'Авто'],
  transportFlight: ['항공', 'Flight', 'Máy bay', 'Авиа'],
  fxLive: [
    '실시간 환율 자동 적용',
    'Apply live exchange rate',
    'Áp dụng tỷ giá realtime',
    'Живой курс автоматически',
  ],
  fxFixed: [
    '내가 직접 환율 설정',
    'Set my own rate',
    'Tự đặt tỷ giá',
    'Задать курс вручную',
  ],
  tristateIncluded: ['포함', 'Included', 'Bao gồm', 'Включено'],
  tristateExcluded: ['불포함', 'Excluded', 'Không gồm', 'Не включено'],
  tristateNa: ['해당없음', 'N/A', 'Không áp dụng', 'Н/Д'],
  mealBreakfast: ['조식', 'Breakfast', 'Bữa sáng', 'Завтрак'],
  mealLunch: ['중식', 'Lunch', 'Bữa trưa', 'Обед'],
  mealDinner: ['석식', 'Dinner', 'Bữa tối', 'Ужин'],
};

const pkgShell = {
  titleCreate: ['패키지 등록', 'Create package', 'Đăng gói', 'Создать пакет'],
  titleEdit: ['패키지 수정', 'Edit package', 'Sửa gói', 'Редактировать пакет'],
  planLock: [
    '패키지 상품은 유료 플랜에서 사용할 수 있어요',
    'Packages require a paid plan',
    'Gói cần gói trả phí',
    'Пакеты доступны на платном плане',
  ],
  editBadge: ['수정 중', 'Editing', 'Đang sửa', 'Редактирование'],
  savedAt: ['저장 {time}', 'Saved {time}', 'Đã lưu {time}', 'Сохранено {time}'],
  autoSave: ['자동 저장됨', 'Autosaved', 'Tự động lưu', 'Автосохранение'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  publishNow: ['지금 공개하기', 'Publish now', 'Công khai ngay', 'Опубликовать сейчас'],
  saveEdit: ['수정 완료', 'Save changes', 'Lưu sửa', 'Сохранить'],
  discardConfirm: [
    '저장되지 않은 변경사항이 있어요. 나가시겠습니까?',
    'You have unsaved changes. Leave this page?',
    'Có thay đổi chưa lưu. Thoát trang?',
    'Есть несохранённые изменения. Выйти?',
  ],
  toastLoadFailed: [
    '기존 패키지 정보를 불러오지 못했어요',
    'Could not load package',
    'Không tải được gói',
    'Не удалось загрузить пакет',
  ],
  toastCopied: [
    '복사됐어요. 날짜와 가격을 수정해 주세요',
    'Copied. Update dates and prices',
    'Đã sao chép. Hãy sửa ngày và giá',
    'Скопировано. Обновите даты и цены',
  ],
  toastNeedTitle: [
    '상품명을 입력해 주세요',
    'Please enter a title',
    'Vui lòng nhập tên sản phẩm',
    'Введите название',
  ],
  toastDraftFailed: ['임시저장 실패', 'Draft save failed', 'Lưu nháp thất bại', 'Черновик не сохранён'],
  toastPublished: [
    '패키지가 게시됐어요! 🎉',
    'Package published! 🎉',
    'Đã đăng gói! 🎉',
    'Пакет опубликован! 🎉',
  ],
  toastNoPackageId: [
    '패키지 ID를 만들지 못했어요',
    'Could not create package ID',
    'Không tạo được ID gói',
    'Не удалось создать ID пакета',
  ],
  defaultTitle: ['새 패키지', 'New package', 'Gói mới', 'Новый пакет'],
  defaultTitleCopy: ['새 패키지 (복사)', 'New package (copy)', 'Gói mới (sao chép)', 'Новый пакет (копия)'],
  titleCopySuffix: [' (복사)', ' (copy)', ' (sao chép)', ' (копия)'],
};

// TODO: 확인 필요 - 박수 = nights count
const pkgBasic = {
  title: ['상품명', 'Title', 'Tên sản phẩm', 'Название'],
  nights: ['박수', 'Nights', 'Số đêm', 'Ночи'],
  nightSuffix: ['박', 'nights', 'đêm', 'ноч.'],
  nightsPh: ['예: 3', 'e.g. 3', 'vd: 3', 'напр. 3'],
  days: ['일수', 'Days', 'Số ngày', 'Дни'],
  daySuffix: ['일', 'days', 'ngày', 'дн.'],
  daysPh: ['예: 5', 'e.g. 5', 'vd: 5', 'напр. 5'],
  daysOrderError: [
    '일수는 박수보다 같거나 커야 해요',
    'Days must be greater than or equal to nights',
    'Số ngày phải ≥ số đêm',
    'Дней должно быть ≥ ночей',
  ],
  tripGuide1: [
    '야간 비행 포함 시 일수가 박수보다 많을 수 있어요.',
    'With overnight flights, days can exceed nights.',
    'Có chuyến bay đêm thì số ngày có thể > số đêm.',
    'С ночными рейсами дней может быть больше ночей.',
  ],
  tripGuide2: ['예: 밤 출발 → 3박5일', 'e.g. night departure → 3N/5D', 'vd: bay đêm → 3 đêm 5 ngày', 'напр. ночной вылет → 3Н/5Д'],
  tripGuide3: ['유럽 장기 → 15박17일', 'Long Europe trip → 15N/17D', 'Tour châu Âu dài → 15 đêm 17 ngày', 'Долгий тур по Европе → 15Н/17Д'],
  durationShort: ['{n}박{d}일', '{n}N/{d}D', '{n}N/{d}D', '{n}Н/{d}Д'],
  tripLabel: [
    '{label} · Day 1~{n} ({n}개 일정 카드 자동 생성)',
    '{label} · Day 1–{n} ({n} itinerary cards auto-created)',
    '{label} · Day 1–{n} (tự tạo {n} thẻ lịch trình)',
    '{label} · День 1–{n} (авто {n} карточек)',
  ],
  dayCardsHint: [
    '일정 카드가 자동으로 생성돼요',
    'Itinerary cards are created automatically',
    'Thẻ lịch trình được tạo tự động',
    'Карточки маршрута создаются автоматически',
  ],
  departDays: ['정기 운영 요일', 'Operating days', 'Ngày vận hành', 'Дни работы'],
  departHint1: [
    '매주 반복되는 출발 가능 요일을 선택하세요.',
    'Pick weekly departure weekdays.',
    'Chọn các thứ khởi hành lặp hàng tuần.',
    'Выберите дни выезда каждую неделю.',
  ],
  departHint2: ['예: 매주 월·수·금 출발', 'e.g. every Mon/Wed/Fri', 'vd: mỗi T2/T4/T6', 'напр. каждый Пн/Ср/Пт'],
  bookingDeadline: ['예약 마감', 'Booking deadline', 'Hạn đặt', 'Дедлайн брони'],
  minGuests: ['최소 인원', 'Min guests', 'Tối thiểu', 'Мин. гостей'],
  maxGuests: ['최대 인원', 'Max guests', 'Tối đa', 'Макс. гостей'],
  bookingMode: ['예약 방식', 'Booking mode', 'Cách đặt', 'Способ брони'],
  cancellation: ['취소 정책', 'Cancellation', 'Chính sách hủy', 'Отмена'],
  optionalSection: ['선택 항목', 'Optional', 'Tuỳ chọn', 'Опционально'],
  difficulty: ['난이도', 'Difficulty', 'Độ khó', 'Сложность'],
  none: ['없음', 'None', 'Không', 'Нет'],
  audience: ['추천 대상', 'Audience', 'Đối tượng', 'Аудитория'],
  childrenAllowed: ['아동 동반 가능', 'Children allowed', 'Cho phép trẻ em', 'Дети разрешены'],
  guideLanguage: ['가이드 언어', 'Guide language', 'Ngôn ngữ HDV', 'Язык гида'],
  kakao: ['카카오톡 ID', 'KakaoTalk ID', 'ID KakaoTalk', 'KakaoTalk ID'],
  emergency: ['긴급 연락처', 'Emergency contact', 'Liên hệ khẩn', 'Экстренный контакт'],
};

const pkgPricing = {
  guide: [
    '성인·아동·유아 요금을 설정하세요. 필요 시 1인실 추가를 켤 수 있어요.',
    'Set adult, child, and infant rates. Enable single supplement if needed.',
    'Đặt giá người lớn, trẻ em, trẻ nhỏ. Bật phụ thu phòng đơn nếu cần.',
    'Задайте цены взрослого, ребёнка и младенца. При необходимости — доплата за single.',
  ],
  currency: ['통화', 'Currency', 'Tiền tệ', 'Валюта'],
  adult: ['성인', 'Adult', 'Người lớn', 'Взрослый'],
  child: ['아동', 'Child', 'Trẻ em', 'Ребёнок'],
  infant: ['유아', 'Infant', 'Trẻ nhỏ', 'Младенец'],
  single: ['1인실 추가', 'Single supplement', 'Phụ thu phòng đơn', 'Доплата за single'],
  childHint: [
    '보통 만 2–11세 기준',
    'Usually ages 2–11',
    'Thường 2–11 tuổi',
    'Обычно 2–11 лет',
  ],
  infantHint: [
    '보통 만 2세 미만',
    'Usually under 2',
    'Thường dưới 2 tuổi',
    'Обычно до 2 лет',
  ],
  free: ['무료', 'Free', 'Miễn phí', 'Бесплатно'],
  splitToggle: ['요금 분리', 'Split pricing', 'Tách giá', 'Раздельные цены'],
  expatToggle: ['교민 할인가', 'Expat discount', 'Giảm giá kiều bào', 'Скидка для экспатов'],
  fxMode: ['환율 적용', 'FX mode', 'Tỷ giá', 'Курс'],
  fxQuestion: [
    '다른 통화로도 표시할까요?',
    'Show other currencies too?',
    'Hiển thị thêm tiền tệ khác?',
    'Показывать другие валюты?',
  ],
  depositCurrency: ['예약금 통화', 'Deposit currency', 'Tiền tệ đặt cọc', 'Валюта депозита'],
  depositAmount: ['예약금 금액', 'Deposit amount', 'Số tiền đặt cọc', 'Сумма депозита'],
  balanceCurrency: ['잔금 통화', 'Balance currency', 'Tiền tệ còn lại', 'Валюта остатка'],
  balanceAmount: ['잔금 금액', 'Balance amount', 'Số tiền còn lại', 'Сумма остатка'],
  discountPercent: ['할인율 (%)', 'Discount (%)', 'Giảm (%)', 'Скидка (%)'],
  discountCondition: ['적용 조건', 'Conditions', 'Điều kiện', 'Условия'],
  fxManualLabel: [
    '환율 직접 입력 ({from} → KRW)',
    'Enter FX rate ({from} → KRW)',
    'Nhập tỷ giá ({from} → KRW)',
    'Ввести курс ({from} → KRW)',
  ],
  fxBaseUnitAria: ['기준 단위', 'Base unit', 'Đơn vị cơ sở', 'Базовая единица'],
  fxKrwAria: ['KRW 환율', 'KRW rate', 'Tỷ giá KRW', 'Курс KRW'],
  fxHint: [
    '환산: (가격 ÷ 기준단위) × KRW값 — 예) 2,500,000 VND ÷ 1,000 × 54 = 약 135,000 KRW',
    'Convert: (price ÷ base unit) × KRW — e.g. 2,500,000 VND ÷ 1,000 × 54 ≈ 135,000 KRW',
    'Đổi: (giá ÷ đơn vị gốc) × KRW — vd: 2.500.000 VND ÷ 1.000 × 54 ≈ 135.000 KRW',
    'Пересчёт: (цена ÷ база) × KRW — напр. 2 500 000 VND ÷ 1 000 × 54 ≈ 135 000 KRW',
  ],
  approxPrefix: ['약 {amount}', '≈ {amount}', 'khoảng {amount}', 'ок. {amount}'],
};

const pkgFinish = {
  guide: [
    '하이라이트와 대표 사진으로 미리보기를 완성하세요.',
    'Finish the preview with highlights and a cover photo.',
    'Hoàn thiện xem trước bằng điểm nổi bật và ảnh bìa.',
    'Завершите превью: хайлайты и обложка.',
  ],
  highlightN: ['하이라이트 {n}', 'Highlight {n}', 'Nổi bật {n}', 'Хайлайт {n}'],
  highlightPh1: [
    '예: 바나힐 야경 포함',
    'e.g. Ba Na Hills night view',
    'vd: Đêm Ba Na Hills',
    'напр. ночной вид Ba Na Hills',
  ],
  highlightPh2: [
    '예: 한국인 가이드 동행',
    'e.g. Korean guide included',
    'vd: Có HDV Hàn',
    'напр. корейский гид',
  ],
  highlightPh3: [
    '예: 로컬 맛집 3곳 포함',
    'e.g. 3 local restaurants included',
    'vd: Gồm 3 quán local',
    'напр. 3 местных ресторана',
  ],
  thumb: ['대표 썸네일', 'Cover thumbnail', 'Ảnh bìa', 'Обложка'],
  gallery: ['갤러리 사진', 'Gallery photos', 'Ảnh gallery', 'Галерея'],
  previewBtn: ['미리보기', 'Preview', 'Xem trước', 'Превью'],
};

const pkgTerms = {
  precautions: ['유의사항', 'Precautions', 'Lưu ý', 'Важные замечания'],
  cancelDetail: ['취소/환불 상세 규정', 'Cancel / refund details', 'Chi tiết hủy/hoàn', 'Детали отмены/возврата'],
  payment: ['결제 안내', 'Payment guide', 'Hướng dẫn thanh toán', 'Оплата'],
  benefit: ['혜택/할인', 'Benefits / discounts', 'Ưu đãi / giảm giá', 'Бонусы / скидки'],
  insurance: ['보험 안내', 'Insurance', 'Bảo hiểm', 'Страховка'],
  emergency: ['긴급 연락 절차', 'Emergency procedure', 'Quy trình khẩn cấp', 'Экстренная процедура'],
  packing: ['준비물 체크리스트', 'Packing checklist', 'Checklist mang theo', 'Что взять с собой'],
  luggage: ['캐리어/수하물 규정', 'Luggage rules', 'Quy định hành lý', 'Правила багажа'],
  sectionPay: ['결제/혜택/보험', 'Payment / benefits / insurance', 'Thanh toán / ưu đãi / BH', 'Оплата / бонусы / страховка'],
  sectionEmergency: ['비상 연락처', 'Emergency contacts', 'Liên hệ khẩn', 'Экстренные контакты'],
  emergencyGuide: [
    '투어 당일 문제 발생 시 유저가 연락할 수 있는 정보',
    'Who travelers can contact if something goes wrong on the day',
    'Thông tin liên hệ khi sự cố trong ngày tour',
    'Куда писать, если в день тура что-то пошло не так',
  ],
  contactName: ['현지 담당자 이름', 'Local contact name', 'Tên người phụ trách', 'Имя местного контакта'],
  localPhone: ['현지 전화번호', 'Local phone', 'SĐT địa phương', 'Местный телефон'],
  kakaoId: ['카카오톡 ID', 'KakaoTalk ID', 'ID KakaoTalk', 'KakaoTalk ID'],
  whatsapp: ['WhatsApp', 'WhatsApp', 'WhatsApp', 'WhatsApp'],
  customInput: ['+ 직접입력', '+ Custom', '+ Tự nhập', '+ Своё'],
  precautionsPh: [
    '예: 우천 시 일정이 변경될 수 있습니다.\n최소 출발 인원 미달 시 투어가 취소될 수 있으며, 출발 3일 전 안내드립니다.',
    'e.g. Schedule may change in rain.\nTour may cancel if minimum guests not met; we notify 3 days before.',
    'vd: Lịch có thể đổi khi mưa.\nTour có thể hủy nếu thiếu min khách; báo trước 3 ngày.',
    'напр. Маршрут может измениться при дожде.\nТур могут отменить при недоборе; уведомляем за 3 дня.',
  ],
  cancelDetailPh: [
    '예: 출발 7일 전: 100% 환불\n출발 3일 전: 50% 환불\n출발 1일 전: 환불 불가\n노쇼: 환불 불가',
    'e.g. 7 days before: 100% refund\n3 days before: 50%\n1 day before: no refund\nNo-show: no refund',
    'vd: Trước 7 ngày: hoàn 100%\nTrước 3 ngày: 50%\nTrước 1 ngày: không hoàn\nNo-show: không hoàn',
    'напр. За 7 дней: 100%\nЗа 3 дня: 50%\nЗа 1 день: без возврата\nНеявка: без возврата',
  ],
  paymentPh: [
    '예: 예약금은 한국 계좌로 입금, 잔금은 현지에서 가이드에게 지불',
    'e.g. Deposit to Korea account; balance paid to guide locally',
    'vd: Đặt cọc vào TK Hàn; còn lại trả HDV tại chỗ',
    'напр. Депозит на счёт в Корее; остаток гиду на месте',
  ],
  benefitPh: [
    '예: 현지 거주 교민 10% 할인 적용, 카카오톡 문의 시 추가 혜택',
    'e.g. 10% off for local expats; extra perks via KakaoTalk inquiry',
    'vd: Kiều bào giảm 10%; ưu đãi thêm khi hỏi KakaoTalk',
    'напр. 10% для экспатов; бонус при запросе в KakaoTalk',
  ],
  insurancePh: [
    '예: 여행자보험 포함\n의료비 최대 $100,000 보장\n보험사: 삼성화재',
    'e.g. Travel insurance included\nMedical up to $100,000\nInsurer: Samsung Fire',
    'vd: Có BH du lịch\nY tế tối đa $100,000\nHãng: Samsung Fire',
    'напр. Страховка включена\nМед. до $100,000\nСтраховщик: Samsung Fire',
  ],
  contactNamePh: ['예: 김민준 가이드', 'e.g. Guide Minjun Kim', 'vd: HDV Minjun Kim', 'напр. гид Minjun Kim'],
  whatsappPh: ['예: +84 123 456 789', 'e.g. +84 123 456 789', 'vd: +84 123 456 789', 'напр. +84 123 456 789'],
  emergencyPh: [
    '예: 1. 담당 가이드에게 먼저 연락\n2. 연결 안 될 시 업체 대표번호로\n3. 긴급 시 현지 경찰 191',
    'e.g. 1. Contact assigned guide first\n2. If unreachable, call business line\n3. In emergency, local police 191',
    'vd: 1. Gọi HDV phụ trách trước\n2. Không được thì gọi số công ty\n3. Khẩn cấp: cảnh sát 191',
    'напр. 1. Сначала гиду\n2. Если нет связи — в офис\n3. Срочно: полиция 191',
  ],
  luggagePh: [
    '예: 1인당 24인치 캐리어 1개 가능, 골프백은 사전 문의 필수',
    'e.g. One 24" suitcase per person; golf bags need prior approval',
    'vd: 1 vali 24" / người; túi golf cần hỏi trước',
    'напр. 1 чемодан 24" на человека; гольф-сумки — по запросу',
  ],
};

const pkgItin = {
  cardTitle: ['Day {n}', 'Day {n}', 'Day {n}', 'День {n}'],
  up: ['위로', 'Up', 'Lên', 'Вверх'],
  down: ['아래로', 'Down', 'Xuống', 'Вниз'],
  delete: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  time: ['시간', 'Time', 'Giờ', 'Время'],
  place: ['장소', 'Place', 'Địa điểm', 'Место'],
  transport: ['이동수단', 'Transport', 'Di chuyển', 'Транспорт'],
  images: ['사진', 'Photos', 'Ảnh', 'Фото'],
  desc: ['설명', 'Description', 'Mô tả', 'Описание'],
  addSchedule: ['일정 추가', 'Add schedule', 'Thêm lịch trình', 'Добавить пункт'],
  copyDay: ['Day 복사', 'Copy day', 'Sao chép ngày', 'Копировать день'],
  guide: [
    '하루 일정을 시간 순으로 추가하세요.',
    'Add the day’s activities in time order.',
    'Thêm lịch trình trong ngày theo thứ tự giờ.',
    'Добавляйте активности дня по времени.',
  ],
};

const pkgServices = {
  section: ['포함 서비스', 'Included services', 'Dịch vụ bao gồm', 'Включённые услуги'],
  guide: [
    '포함·불포함 항목을 선택하세요. 숙소·식사도 여기서 설정할 수 있어요.',
    'Choose what’s included or not. Hotels and meals can be set here too.',
    'Chọn mục bao gồm / không. Có thể đặt khách sạn & bữa ăn tại đây.',
    'Выберите включённое и исключённое. Отель и питание — тоже здесь.',
  ],
};

/** Large UI strings for StepServiceSections */
const pkgServicesUi = {
  dayOf: ['Day {n} / {total}일', 'Day {n} / {total} days', 'Day {n} / {total} ngày', 'День {n} / {total} дн.'],
  copyPrevDay: ['이전 Day 복사', 'Copy previous day', 'Sao chép ngày trước', 'Копировать предыдущий день'],
  desc: ['설명', 'Description', 'Mô tả', 'Описание'],
  mealBreakfastPh: ['예: 호텔 조식 뷔페', 'e.g. Hotel breakfast buffet', 'vd: Buffet sáng KS', 'напр. завтрак-буфет в отеле'],
  mealLunchPh: ['예: 현지식 쌀국수', 'e.g. Local pho', 'vd: Phở địa phương', 'напр. местный фо'],
  mealDinnerPh: ['예: 해산물 레스토랑', 'e.g. Seafood restaurant', 'vd: Nhà hàng hải sản', 'напр. морепродукты'],
  guideDescPhKrIn: [
    '예: 한국인 가이드 전일정 동행',
    'e.g. Korean guide for the full itinerary',
    'vd: HDV Hàn suốt lịch trình',
    'напр. корейский гид на всём маршруте',
  ],
  guideDescPhLocalIn: [
    '예: 현지 가이드 바나힐 구간 동행',
    'e.g. Local guide for Ba Na Hills segment',
    'vd: HDV local đoạn Ba Na Hills',
    'напр. местный гид на участке Ba Na Hills',
  ],
  guideDescPhKrOut: [
    '예: 한국어 가이드 미포함',
    'e.g. Korean-speaking guide not included',
    'vd: Không có HDV tiếng Hàn',
    'напр. гид с корейским не включён',
  ],
  guideDescPhLocalOut: [
    '예: 현지 가이드 미포함',
    'e.g. Local guide not included',
    'vd: Không có HDV local',
    'напр. местный гид не включён',
  ],
  tipLabelGuide: ['가이드 팁', 'Guide tip', 'Tip HDV', 'Чаевые гиду'],
  tipLabelLocalGuide: ['로컬 가이드 팁', 'Local guide tip', 'Tip HDV local', 'Чаевые местному гиду'],
  tipPhKrIn: ['예: 가이드 팁 $5/인 포함', 'e.g. Guide tip $5/person included', 'vd: Tip HDV $5/người gồm', 'напр. чаевые гиду $5/чел включены'],
  tipPhLocalIn: [
    '예: 로컬 가이드 팁 $3/인 포함',
    'e.g. Local guide tip $3/person included',
    'vd: Tip HDV local $3/người gồm',
    'напр. чаевые местному $3/чел включены',
  ],
  tipPhKrOut: ['예: $5/인 권장', 'e.g. $5/person recommended', 'vd: Gợi ý $5/người', 'напр. рекомендуется $5/чел'],
  tipPhLocalOut: ['예: $3/인 권장', 'e.g. $3/person recommended', 'vd: Gợi ý $3/người', 'напр. рекомендуется $3/чел'],
  vehicleGuide: [
    '선택한 인원수에 맞는 차량이 자동 배정됩니다',
    'A vehicle matching your guest count is assigned automatically',
    'Xe khớp số khách sẽ được gán tự động',
    'Авто под ваше число гостей назначается автоматически',
  ],
  vehicleCustomPh: ['차량 종류 직접 입력', 'Enter vehicle type', 'Nhập loại xe', 'Введите тип авто'],
  driverTip: ['기사 팁', 'Driver tip', 'Tip tài xế', 'Чаевые водителю'],
  driverTipPhIn: ['예: 기사 팁 $2/인 포함', 'e.g. Driver tip $2/person included', 'vd: Tip tài xế $2/người gồm', 'напр. чаевые водителю $2/чел включены'],
  driverTipPhOut: ['예: $2/인 권장', 'e.g. $2/person recommended', 'vd: Gợi ý $2/người', 'напр. рекомендуется $2/чел'],
  waterPhIn: [
    '예: 1인당 생수 1병/일 제공',
    'e.g. 1 bottle of water per person / day',
    'vd: 1 chai nước / người / ngày',
    'напр. 1 бутылка воды на чел./день',
  ],
  waterPhOut: ['예: 현지 구매 필요', 'e.g. Buy locally', 'vd: Mua tại chỗ', 'напр. купить на месте'],
  shopping: ['쇼핑센터', 'Shopping stop', 'Trung tâm mua sắm', 'Шоппинг'],
  shoppingOff: ['쇼핑 없음', 'No shopping', 'Không shopping', 'Без шоппинга'],
  visitCount: ['방문 횟수', 'Visit count', 'Số lần thăm', 'Число визитов'],
  visit1: ['1회', '1 time', '1 lần', '1 раз'],
  visit2: ['2회', '2 times', '2 lần', '2 раза'],
  visit3Plus: ['3회 이상', '3+ times', 'Từ 3 lần', '3+ раза'],
  placeName: ['장소명', 'Place name', 'Tên địa điểm', 'Название места'],
  placeNamePh: ['예: 다낭 한시장', 'e.g. Da Nang Korean market', 'vd: Chợ Hàn Đà Nẵng', 'напр. корейский рынок в Дананге'],
  stayDuration: ['예상 체류시간', 'Expected duration', 'Thời gian ở lại', 'Ожидаемое время'],
  stayDurationPh: ['예: 30분', 'e.g. 30 min', 'vd: 30 phút', 'напр. 30 мин'],
  visitMandatory: ['의무 방문', 'Mandatory visit', 'Bắt buộc', 'Обязательный визит'],
  visitOptional: ['자유 선택', 'Optional', 'Tuỳ chọn', 'По желанию'],
  addPlace: ['+ 장소 추가', '+ Add place', '+ Thêm địa điểm', '+ Добавить место'],
  venueN: ['입장지 {n}', 'Venue {n}', 'Địa điểm vào {n}', 'Объект {n}'],
  venuePh: ['예: 바나힐', 'e.g. Ba Na Hills', 'vd: Ba Na Hills', 'напр. Ba Na Hills'],
  includeStatus: ['포함 여부', 'Inclusion', 'Bao gồm?', 'Включено?'],
  admissionIncluded: ['✔ 입장료 포함', '✔ Admission included', '✔ Vé gồm sẵn', '✔ Вход включён'],
  admissionOnSite: ['✖ 입장료 현장 지불', '✖ Pay admission on-site', '✖ Trả vé tại chỗ', '✖ Вход оплатить на месте'],
  amountOptional: ['금액 (선택)', 'Amount (optional)', 'Số tiền (tuỳ chọn)', 'Сумма (опц.)'],
  amountPh: ['예: 750,000', 'e.g. 750,000', 'vd: 750.000', 'напр. 750 000'],
  currency: ['통화', 'Currency', 'Tiền tệ', 'Валюта'],
  addVenue: ['+ 입장지 추가', '+ Add venue', '+ Thêm địa điểm', '+ Добавить объект'],
  excludesTitle: ['포함되지 않는 항목', 'Not included', 'Không bao gồm', 'Не включено'],
  excludesGuide: [
    '유저가 미리 알아야 하는 불포함 항목을 입력하세요',
    'List exclusions travelers should know in advance',
    'Nhập mục không gồm mà khách cần biết sớm',
    'Укажите исключения, о которых стоит знать заранее',
  ],
  customInput: ['+ 직접입력', '+ Custom', '+ Tự nhập', '+ Своё'],
  optionalTitle: [
    '현장에서 별도 지불하는 비용',
    'Pay on-site separately',
    'Chi phí trả tại chỗ',
    'Оплата отдельно на месте',
  ],
  optionalGuide: [
    '미리 안내하면 분쟁을 예방할 수 있어요. 유저 화면에 표시됩니다',
    'Clear notice prevents disputes. Shown on the traveler screen.',
    'Thông báo sớm giảm tranh chấp. Hiện trên màn khách.',
    'Заранее — меньше споров. Показывается гостю.',
  ],
  itemName: ['항목명', 'Item name', 'Tên mục', 'Название'],
  itemNamePh: ['예: 바나힐 입장료', 'e.g. Ba Na Hills admission', 'vd: Vé Ba Na Hills', 'напр. вход Ba Na Hills'],
  amount: ['금액', 'Amount', 'Số tiền', 'Сумма'],
  unit: ['단위', 'Unit', 'Đơn vị', 'Единица'],
  unitPerPerson: ['1인당', 'Per person', '/ người', 'На человека'],
  unitTotal: ['전체', 'Total', 'Tổng', 'Всего'],
  note: ['비고', 'Note', 'Ghi chú', 'Примечание'],
  notePh: [
    '예: 성인 기준, 현장 현금 지불',
    'e.g. Adult rate; cash on-site',
    'vd: Giá người lớn; trả tiền mặt tại chỗ',
    'напр. тариф взрослого; наличные на месте',
  ],
  deleteItem: ['항목 삭제', 'Delete item', 'Xóa mục', 'Удалить'],
  addItem: ['+ 항목 추가', '+ Add item', '+ Thêm mục', '+ Добавить'],
  airline: ['항공사명', 'Airline', 'Hãng bay', 'Авиакомпания'],
  airlinePh: ['예: 베트남항공', 'e.g. Vietnam Airlines', 'vd: Vietnam Airlines', 'напр. Vietnam Airlines'],
  flightNo: ['편명', 'Flight no.', 'Số hiệu', 'Рейс'],
  flightNoPh: ['예: VN123', 'e.g. VN123', 'vd: VN123', 'напр. VN123'],
  departAirport: ['출발공항', 'Departure airport', 'Sân bay đi', 'Аэропорт вылета'],
  departAirportPh: ['예: 인천 ICN', 'e.g. Incheon ICN', 'vd: Incheon ICN', 'напр. Инчхон ICN'],
  arriveAirport: ['도착공항', 'Arrival airport', 'Sân bay đến', 'Аэропорт прилёта'],
  arriveAirportPh: ['예: 다낭 DAD', 'e.g. Da Nang DAD', 'vd: Đà Nẵng DAD', 'напр. Дананг DAD'],
  departTime: ['출발 시간', 'Departure time', 'Giờ đi', 'Время вылета'],
  arriveTime: ['도착 시간', 'Arrival time', 'Giờ đến', 'Время прилёта'],
  outbound: ['가는 편', 'Outbound', 'Chiều đi', 'Туда'],
  inbound: ['오는 편', 'Return', 'Chiều về', 'Обратно'],
  flight: ['항공', 'Flight', 'Máy bay', 'Авиа'],
  flightOff: ['항공 미포함', 'Flight not included', 'Không gồm máy bay', 'Авиа не включено'],
  flightDateHint: [
    '항공 날짜는 유저가 예약 시 선택한 출발일에 자동으로 맞춰집니다. 시간만 입력하세요.',
    'Flight dates follow the traveler’s chosen departure date. Enter times only.',
    'Ngày bay khớp ngày khởi hành khách chọn. Chỉ nhập giờ.',
    'Даты рейса = выбранная гостем дата выезда. Введите только время.',
  ],
  layover: ['경유 여부', 'Has layover', 'Có quá cảnh', 'С пересадкой'],
  layoverPlace: ['경유지', 'Layover city', 'Điểm quá cảnh', 'Город пересадки'],
  layoverWait: ['대기시간', 'Wait time', 'Thời gian chờ', 'Ожидание'],
  layoverWaitPh: ['예: 2시간', 'e.g. 2 hours', 'vd: 2 giờ', 'напр. 2 часа'],
  checkedBag: ['위탁수하물', 'Checked baggage', 'Hành lý ký gửi', 'Багаж'],
  cabinBag: ['기내수하물', 'Cabin baggage', 'Hành lý xách tay', 'Ручная кладь'],
  previewDay1: ['Day 1 표시: {text}', 'Day 1 shows: {text}', 'Day 1 hiện: {text}', 'День 1: {text}'],
  previewDayN: ['Day {n} 표시: {text}', 'Day {n} shows: {text}', 'Day {n} hiện: {text}', 'День {n}: {text}'],
  insurance: ['보험', 'Insurance', 'Bảo hiểm', 'Страховка'],
  insurer: ['보험사명', 'Insurer', 'Công ty BH', 'Страховщик'],
  insurerPh: ['예: 삼성화재', 'e.g. Samsung Fire', 'vd: Samsung Fire', 'напр. Samsung Fire'],
  coverage: ['보장내용', 'Coverage', 'Phạm vi BH', 'Покрытие'],
  coveragePh: [
    '예: 여행자보험 포함, 의료비 최대 $100,000',
    'e.g. Travel insurance included; medical up to $100,000',
    'vd: Có BH du lịch; y tế tối đa $100,000',
    'напр. страховка включена; мед. до $100,000',
  ],
  hotelType: ['숙소 타입', 'Hotel type', 'Loại KS', 'Тип отеля'],
  hotelName: ['숙소명', 'Hotel name', 'Tên KS', 'Название отеля'],
  hotelNamePh: ['예: 빈펄 리조트 다낭', 'e.g. Vinpearl Resort Da Nang', 'vd: Vinpearl Resort Đà Nẵng', 'напр. Vinpearl Resort Дананг'],
  checkIn: ['체크인', 'Check-in', 'Nhận phòng', 'Заезд'],
  checkOut: ['체크아웃', 'Check-out', 'Trả phòng', 'Выезд'],
  // vehicle chip labels (values stay codes)
  vehicleSedan: ['1~4인 → 세단', '1–4 → Sedan', '1–4 → Sedan', '1–4 → седан'],
  vehicleSuv: ['5~6인 → SUV', '5–6 → SUV', '5–6 khách → SUV', '5–6 чел. → SUV'],
  vehicleMinivan: ['7~9인 → 미니밴', '7–9 → Minivan', '7–9 → Minivan', '7–9 → минивэн'],
  vehicleMidbus: ['10~20인 → 중형버스', '10–20 → Mid bus', '10–20 → Xe mid', '10–20 → средний автобус'],
  vehicleLargebus: ['21인 이상 → 대형버스', '21+ → Coach', '21+ → Xe lớn', '21+ → большой автобус'],
  vehicleCustom: ['직접입력', 'Custom', 'Tự nhập', 'Своё'],
  // TODO: 확인 필요 — EXCLUDE_CHIPS / OPTIONAL_COST_CHIPS stored as Korean labels for hydrate
  excludeFlight: ['항공권', 'Airfare', 'Vé máy bay', 'Авиабилеты'],
  excludePersonal: ['개인경비', 'Personal expenses', 'Chi phí cá nhân', 'Личные расходы'],
  excludeInsurance: ['여행자보험', 'Travel insurance', 'BH du lịch', 'Страховка'],
  excludeShopping: ['쇼핑비용', 'Shopping', 'Chi phí shopping', 'Шоппинг'],
  excludeTip: ['팁', 'Tips', 'Tip', 'Чаевые'],
  excludeVisa: ['비자비용', 'Visa fees', 'Phí visa', 'Виза'],
  optAdmission: ['입장료', 'Admission', 'Vé vào', 'Вход'],
  optDriverTip: ['기사 팁', 'Driver tip', 'Tip tài xế', 'Чаевые водителю'],
  optGuideTip: ['가이드 팁', 'Guide tip', 'Tip HDV', 'Чаевые гиду'],
  optRestaurantTip: ['레스토랑 팁', 'Restaurant tip', 'Tip nhà hàng', 'Чаевые в ресторане'],
  optFuel: ['유류할증료', 'Fuel surcharge', 'Phụ thu nhiên liệu', 'Топливный сбор'],
  optPorterTip: ['포터 팁', 'Porter tip', 'Tip porter', 'Чаевые носильщику'],
  bagNone: ['없음', 'None', 'Không', 'Нет'],
};

const pkgIe = {
  includeTitle: ['포함사항', 'Included', 'Bao gồm', 'Включено'],
  excludeTitle: ['불포함사항', 'Excluded', 'Không gồm', 'Не включено'],
  includeHint: [
    '팁 항목은 성인·아동·유아별 금액을 입력할 수 있어요',
    'For tip items you can set adult / child / infant amounts',
    'Tip có thể nhập theo người lớn / trẻ / trẻ nhỏ',
    'Для чаевых можно задать суммы взр./реб./млад.',
  ],
  excludeHint: [
    '별도 팁은 현장 권장 금액을 연령별로 안내할 수 있어요',
    'For separate tips, show recommended on-site amounts by age',
    'Tip riêng có thể gợi ý số tiền tại chỗ theo tuổi',
    'Отдельные чаевые — рекомендуемые суммы на месте по возрасту',
  ],
  groupBasic: ['기본', 'Basics', 'Cơ bản', 'Базовое'],
  groupTipIn: ['팁 (포함)', 'Tips (included)', 'Tip (gồm)', 'Чаевые (вкл.)'],
  groupCostIn: ['기타 비용 (포함)', 'Other costs (included)', 'Chi phí khác (gồm)', 'Прочие (вкл.)'],
  groupTipOut: ['팁 (별도)', 'Tips (extra)', 'Tip (riêng)', 'Чаевые (отдельно)'],
  groupOther: ['기타', 'Other', 'Khác', 'Прочее'],
  customAdd: ['+ 직접입력 추가', '+ Add custom', '+ Thêm tuỳ chỉnh', '+ Добавить своё'],
  tipAsk: [
    '고객에게 얼마를 준비하라고 안내할까요?',
    'How much should guests prepare?',
    'Nên bảo khách chuẩn bị bao nhiêu?',
    'Сколько готовить гостям?',
  ],
  tipAmountIn: ['포함 팁 금액', 'Included tip amount', 'Số tip gồm sẵn', 'Сумма включённых чаевых'],
  tipAmountOut: ['현장 권장 금액', 'Recommended on-site amount', 'Số gợi ý tại chỗ', 'Рекомендуемая сумма на месте'],
  adult: ['성인', 'Adult', 'Người lớn', 'Взрослый'],
  childAge: ['아동 (2~12세)', 'Child (2–12)', 'Trẻ (2–12)', 'Ребёнок (2–12)'],
  infantAge: ['유아 (0~1세)', 'Infant (0–1)', 'Trẻ nhỏ (0–1)', 'Младенец (0–1)'],
  sameAsAdult: ['성인과 동일', 'Same as adult', 'Giống người lớn', 'Как у взрослого'],
  free: ['무료', 'Free', 'Miễn phí', 'Бесплатно'],
  amountPh: ['예: {n}', 'e.g. {n}', 'vd: {n}', 'напр. {n}'],
  guideText: ['추가 안내문구 (선택)', 'Extra note (optional)', 'Ghi chú thêm (tuỳ chọn)', 'Доп. текст (опц.)'],
  guideTextPh: [
    '예: 서비스에 만족하셨다면 $5 정도 권장드립니다',
    'e.g. If you enjoyed the service, ~$5 is appreciated',
    'vd: Nếu hài lòng dịch vụ, gợi ý khoảng $5',
    'напр. если сервис понравился — около $5',
  ],
  applyMode: ['적용 방식', 'How to apply', 'Cách áp dụng', 'Способ'],
  modeAmount: ['금액', 'Amount', 'Số tiền', 'Сумма'],
  modePercent: ['퍼센트(%)', 'Percent (%)', 'Phần trăm (%)', 'Процент (%)'],
  percentLabel: ['비율 (%)', 'Rate (%)', 'Tỷ lệ (%)', 'Ставка (%)'],
  percentHint: ['기준: 전체 식사비', 'Based on total meal cost', 'Theo tổng tiền ăn', 'От суммы питания'],
  percentPh: ['예: 10', 'e.g. 10', 'vd: 10', 'напр. 10'],
  restaurantGuidePh: ['예: 10% 권장', 'e.g. 10% recommended', 'vd: Gợi ý 10%', 'напр. рекомендуется 10%'],
  costAmount: ['{label} 금액', '{label} amount', 'Số tiền {label}', 'Сумма: {label}'],
  costHint: [
    '입력하지 않아도 저장할 수 있어요',
    'You can save without entering an amount',
    'Có thể lưu khi chưa nhập số',
    'Можно сохранить без суммы',
  ],
  amountPlaceholder: ['예: 750,000', 'e.g. 750,000', 'vd: 750.000', 'напр. 750 000'],
  admissionGuide: ['입장료 안내 (선택)', 'Admission note (optional)', 'Ghi chú vé (tuỳ chọn)', 'Заметка о входе (опц.)'],
  admissionGuidePh: [
    '예: 바나힐 성인 750,000 VND',
    'e.g. Ba Na Hills adult 750,000 VND',
    'vd: Ba Na Hills người lớn 750.000 VND',
    'напр. Ba Na Hills взрослый 750 000 VND',
  ],
  unitPerPerson: ['1인당', 'Per person', '/ người', 'На человека'],
  unitPerDay: ['1일당', 'Per day', '/ ngày', 'В день'],
  unitTotal: ['전체', 'Total', 'Tổng', 'Всего'],
  // chip display labels (keys stored; label kept Korean for hydrate — TODO)
  chipKrGuide: ['한국어 가이드', 'Korean guide', 'HDV tiếng Hàn', 'Корейский гид'],
  chipVehicle: ['차량 포함', 'Vehicle included', 'Có xe', 'Авто включено'],
  chipHotelBreakfast: ['호텔 조식', 'Hotel breakfast', 'Buffet KS', 'Завтрак в отеле'],
  chipAdmissionIn: ['입장료 포함', 'Admission included', 'Gồm vé vào', 'Вход включён'],
  chipAirportPickup: ['공항 픽업', 'Airport pickup', 'Đón sân bay', 'Трансфер из аэропорта'],
  chipTipGuide: ['가이드 팁', 'Guide tip', 'Tip HDV', 'Чаевые гиду'],
  chipTipDriver: ['기사 팁', 'Driver tip', 'Tip tài xế', 'Чаевые водителю'],
  chipTipPorter: ['포터 팁', 'Porter tip', 'Tip porter', 'Чаевые носильщику'],
  chipTipRestaurant: ['레스토랑 팁', 'Restaurant tip', 'Tip nhà hàng', 'Чаевые в ресторане'],
  chipCostAdmission: ['입장료', 'Admission', 'Vé vào', 'Вход'],
  chipCostMeal: ['식사비', 'Meal cost', 'Tiền ăn', 'Питание'],
  chipCostFuel: ['유류할증료', 'Fuel surcharge', 'Phụ thu nhiên liệu', 'Топливный сбор'],
  chipFlight: ['항공권', 'Airfare', 'Vé máy bay', 'Авиабилеты'],
  chipPersonal: ['개인경비', 'Personal expenses', 'Chi phí cá nhân', 'Личные расходы'],
  chipInsurance: ['여행자보험', 'Travel insurance', 'BH du lịch', 'Страховка'],
  chipShopping: ['쇼핑비용', 'Shopping', 'Chi phí shopping', 'Шоппинг'],
};

const pkgOwner = {
  titleStep1: ['오너 전용 설정', 'Owner-only settings', 'Chỉ chủ sở hữu', 'Только для владельца'],
  titleStep3: ['오너 전용 · 일정 보강', 'Owner · Itinerary extras', 'Chủ · Bổ sung lịch', 'Владелец · Маршрут'],
  titleStep4: ['시즌별 가격', 'Seasonal pricing', 'Giá theo mùa', 'Сезонные цены'],
  titleStep5: ['오너 전용 · 마무리 보강', 'Owner · Finish extras', 'Chủ · Bổ sung kết', 'Владелец · Финиш'],
  styleLabel: [
    '이 투어의 스타일을 선택하세요',
    'Choose this tour’s style',
    'Chọn phong cách tour',
    'Выберите стиль тура',
  ],
  styleHint: [
    '검색/추천 알고리즘에 활용됩니다',
    'Used for search and recommendations',
    'Dùng cho tìm kiếm / gợi ý',
    'Для поиска и рекомендаций',
  ],
  restrictLabel: [
    '참가 제한이 있으면 선택하세요',
    'Select any participation limits',
    'Chọn hạn chế tham gia (nếu có)',
    'Укажите ограничения участия',
  ],
  restrictHint: [
    '유저 상세 페이지에 주의사항으로 표시됩니다',
    'Shown as a caution on the detail page',
    'Hiện cảnh báo trên trang chi tiết',
    'Показывается как предупреждение на странице',
  ],
  customInput: ['+ 직접입력', '+ Custom', '+ Tự nhập', '+ Своё'],
  blackoutLabel: ['운영 불가 특정 날짜', 'Blackout dates', 'Ngày không vận hành', 'Даты исключения'],
  blackoutHint: [
    '명절·공휴일 등 예외적으로 운영하지 않는 날짜를 선택하세요. 정기 운영 요일이라도 이 날짜는 예약이 차단됩니다. 예: 베트남 뗏(설날), 추석',
    'Pick dates you never operate (holidays, etc.). Even regular weekdays block booking. e.g. Vietnamese Tet, Chuseok',
    'Chọn ngày ngoại lệ không chạy (lễ…). Kể cả thứ định kỳ cũng chặn đặt. vd: Tết VN, Chuseok',
    'Даты, когда не возите (праздники и т.п.). Даже в обычные дни бронирование блокируется. напр. Тет, Чхусок',
  ],
  tipIncluded: ['팁 포함 여부', 'Tips included?', 'Tip có gồm?', 'Чаевые включены?'],
  tipIncludedHint: [
    '총 가격에 팁이 포함되어 있습니다',
    'Tips are included in the total price',
    'Tip đã gồm trong tổng giá',
    'Чаевые входят в общую цену',
  ],
  tipGuide: ['권장 팁 안내', 'Recommended tip note', 'Gợi ý tip', 'Рекомендация по чаевым'],
  localPayLabel: [
    '현지에서 추가 결제 시 가능한 수단',
    'Accepted on-site payment methods',
    'Phương thức trả thêm tại chỗ',
    'Способы доп. оплаты на месте',
  ],
  localPayHint: [
    '유저 상세 페이지에 표시됩니다',
    'Shown on the detail page',
    'Hiện trên trang chi tiết',
    'Показывается на странице детали',
  ],
  simWifi: ['유심/WiFi 제공 여부', 'SIM / WiFi provided?', 'Có SIM/WiFi?', 'SIM / Wi‑Fi?'],
  taxInvoice: [
    '세금계산서/현금영수증 발행 가능 여부',
    'Tax invoice / cash receipt available?',
    'Xuất hoá đơn / biên lai được không?',
    'Счёт / кассовый чек доступны?',
  ],
  taxInvoiceHint: [
    '한국 법인 비용 처리가 필요한 고객을 위한 설정이에요',
    'For customers who need Korean corporate expense receipts',
    'Cho khách cần chứng từ chi phí pháp nhân Hàn',
    'Для клиентов с корп. расходами в Корее',
  ],
  cashReceipt: ['현금영수증 가능', 'Cash receipt OK', 'Có biên lai tiền mặt', 'Кассовый чек OK'],
  taxBill: ['세금계산서 가능', 'Tax invoice OK', 'Có hoá đơn GTGT', 'Счёт-фактура OK'],
  countryInfo: ['나라별 특수 정보 ({cc})', 'Country-specific info ({cc})', 'Thông tin theo nước ({cc})', 'Спец. по стране ({cc})'],
  visa: ['비자 안내', 'Visa info', 'Visa', 'Виза'],
  exchange: ['환전 팁', 'Exchange tips', 'Mẹo đổi tiền', 'Обмен валюты'],
  eArrival: ['전자입국 안내', 'E-arrival guide', 'Hướng dẫn e-arrival', 'Электронная въезд'],
  eTravel: ['eTravel 안내', 'eTravel guide', 'Hướng dẫn eTravel', 'Гид eTravel'],
  dressCode: ['복장 규정', 'Dress code', 'Quy định trang phục', 'Дресс-код'],
  season: ['우기/건기 안내', 'Wet / dry season', 'Mùa mưa / khô', 'Сезон дождей / сухой'],
  internet: ['인터넷 환경 안내', 'Internet situation', 'Tình trạng internet', 'Интернет'],
  seasonalToggle: [
    '시즌별 가격 차등 적용',
    'Different prices by season',
    'Giá khác theo mùa',
    'Разные цены по сезонам',
  ],
  seasonalHint: [
    '성수기/비수기 가격을 다르게 설정할 수 있어요',
    'Set different peak / off-peak prices',
    'Có thể đặt giá cao / thấp điểm khác nhau',
    'Можно задать цены пик / несезон',
  ],
  peak: ['성수기', 'Peak season', 'Cao điểm', 'Высокий сезон'],
  offPeak: ['비수기', 'Off-peak', 'Thấp điểm', 'Низкий сезон'],
  startDate: ['시작일', 'Start date', 'Ngày bắt đầu', 'Начало'],
  endDate: ['종료일', 'End date', 'Ngày kết thúc', 'Конец'],
  adultPrice: ['성인 가격', 'Adult price', 'Giá người lớn', 'Цена взрослого'],
  childPrice: ['아동 가격', 'Child price', 'Giá trẻ em', 'Цена ребёнка'],
  infantPrice: ['유아 가격', 'Infant price', 'Giá trẻ nhỏ', 'Цена младенца'],
  holidaySurcharge: [
    '공휴일 추가요금 (금액 또는 %)',
    'Holiday surcharge (amount or %)',
    'Phụ thu ngày lễ (số hoặc %)',
    'Надбавка в праздник (сумма или %)',
  ],
  holidaySurchargePh: ['예: 10% 또는 50000', 'e.g. 10% or 50000', 'vd: 10% hoặc 50000', 'напр. 10% или 50000'],
  meetingPlace: ['정확한 미팅 장소', 'Exact meeting point', 'Điểm hẹn chính xác', 'Точное место встречи'],
  meetingHint: [
    '고객이 지도 앱으로 바로 찾아올 수 있어요 (Day 1)',
    'Guests can open Maps and find you (Day 1)',
    'Khách mở Maps tìm được ngay (Day 1)',
    'Гость откроет карты и найдёт вас (День 1)',
  ],
  addressPh: ['주소 입력', 'Enter address', 'Nhập địa chỉ', 'Введите адрес'],
  mapsPreview: ['구글맵에서 미리보기', 'Preview in Google Maps', 'Xem trước Google Maps', 'Превью в Google Maps'],
  packing: ['고객 준비물', 'Guest packing list', 'Đồ khách cần mang', 'Что взять гостю'],
  packingHint: [
    '예약 확정 후 고객에게 자동으로 안내됩니다',
    'Sent automatically after booking is confirmed',
    'Tự gửi sau khi xác nhận đặt',
    'Автоматически после подтверждения брони',
  ],
  luggageRule: ['수하물 규정', 'Luggage rules', 'Quy định hành lý', 'Правила багажа'],
  luggageHint: [
    '체크아웃 투어, 공항 픽업 등에서 중요한 정보예요',
    'Important for checkout tours and airport pickups',
    'Quan trọng với tour checkout / đón sân bay',
    'Важно для checkout-туров и трансферов',
  ],
  luggagePh: [
    '예: 1인당 24인치 캐리어 1개 가능, 골프백은 사전 문의 필수',
    'e.g. One 24" suitcase per person; golf bags need prior approval',
    'vd: 1 vali 24" / người; túi golf cần hỏi trước',
    'напр. 1 чемодан 24" на человека; гольф — по запросу',
  ],
  hygiene: ['위생 시설', 'Hygiene facilities', 'Tiện nghi vệ sinh', 'Гигиена'],
  luggageStorage: ['짐 보관 가능 여부', 'Luggage storage available?', 'Có giữ hành lý?', 'Хранение багажа?'],
  extraFee: ['추가요금 있음', 'Extra fee applies', 'Có phụ thu', 'Есть доплата'],
  feeAmount: ['금액', 'Amount', 'Số tiền', 'Сумма'],
  onSiteCosts: [
    '현장에서 별도 지불해야 하는 비용',
    'Costs paid separately on-site',
    'Chi phí trả riêng tại chỗ',
    'Расходы отдельно на месте',
  ],
  onSiteHint: [
    '미리 안내하면 분쟁을 예방할 수 있어요. 유저 상세 페이지에 표시됩니다',
    'Clear notice prevents disputes. Shown on the detail page.',
    'Báo sớm giảm tranh chấp. Hiện trên trang chi tiết.',
    'Заранее — меньше споров. На странице детали.',
  ],
  onSitePh: [
    '예: 바나힐 입장료 현장 지불 (성인 750,000 VND)',
    'e.g. Ba Na Hills admission on-site (adult 750,000 VND)',
    'vd: Vé Ba Na Hills trả tại chỗ (người lớn 750.000 VND)',
    'напр. вход Ba Na Hills на месте (взрослый 750 000 VND)',
  ],
  guideIntro: ['담당 가이드 소개', 'About the guide', 'Giới thiệu HDV', 'О гиде'],
  guideIntroHint: [
    '가이드 정보를 입력하면 고객 신뢰도가 높아져요',
    'Guide info builds traveler trust',
    'Thông tin HDV tăng độ tin',
    'Информация о гиде повышает доверие',
  ],
  guideNamePh: ['예: 김민준 가이드', 'e.g. Guide Minjun Kim', 'vd: HDV Minjun Kim', 'напр. гид Minjun Kim'],
  guideBioPh: [
    '예: 다낭 거주 8년차 한국인 가이드. 다낭/호이안/후에 전문',
    'e.g. Korean guide living in Da Nang 8 years. Da Nang / Hoi An / Hue specialist',
    'vd: HDV Hàn sống Đà Nẵng 8 năm. Chuyên Đà Nẵng/Hội An/Huế',
    'напр. корейский гид в Дананге 8 лет. Дананг / Хойан / Хюэ',
  ],
  voucher: [
    '예약 확정 후 바우처 발급 방식',
    'How vouchers are issued after confirmation',
    'Cách cấp voucher sau xác nhận',
    'Как выдаётся ваучер после подтверждения',
  ],
  voucherHint: [
    '고객에게 예약 확정 시 어떤 방식으로 안내할까요?',
    'How should guests receive confirmation details?',
    'Khách nhận thông tin xác nhận bằng cách nào?',
    'Как сообщать гостю детали подтверждения?',
  ],
  bookingFields: [
    '예약 완료 후 고객에게 요청할 정보',
    'Info to request after booking',
    'Thông tin yêu cầu sau khi đặt',
    'Какие данные запросить после брони',
  ],
  bookingFieldsHint: [
    '예약 완료 후 고객이 마이페이지에서 입력하게 됩니다. 항공/숙소/보험이 포함된 경우 여권 정보를 반드시 체크하세요',
    'Guests enter these in My Page after booking. Always require passport if flights/hotels/insurance are included.',
    'Khách nhập ở My Page sau khi đặt. Bắt buộc hộ chiếu nếu có máy bay/KS/BH.',
    'Гости вводят в «Моей странице» после брони. Паспорт обязателен, если есть авиа/отель/страховка.',
  ],
  copyProduct: [
    '이 상품을 복사해서 새 상품 만들기',
    'Copy this listing into a new one',
    'Sao chép thành sản phẩm mới',
    'Скопировать в новое объявление',
  ],
  copyHint: [
    '날짜와 가격만 바꿔서 빠르게 새 상품을 등록할 수 있어요',
    'Change dates and prices to publish a new listing quickly',
    'Chỉ sửa ngày/giá để đăng nhanh sản phẩm mới',
    'Меняйте даты и цены — и быстро публикуйте новое',
  ],
  copyBtn: ['상품 복사', 'Copy product', 'Sao chép', 'Копировать'],
  internalMemo: ['내부 메모', 'Internal memo', 'Ghi chú nội bộ', 'Внутренняя заметка'],
  internalHint: [
    '고객에게 표시되지 않는 내부용 메모입니다',
    'Internal only — not shown to travelers',
    'Chỉ nội bộ — không hiện cho khách',
    'Только внутри — гости не видят',
  ],
  internalPh: [
    '예: VIP 고객 전용 상품, 알레르기 주의 고객 다수',
    'e.g. VIP-only listing; many guests with allergies',
    'vd: SP dành VIP; nhiều khách dị ứng',
    'напр. только VIP; много гостей с аллергией',
  ],
  // ChipSelect option labels
  styleHealing: ['힐링', 'Healing', 'Healing', 'Релакс'],
  styleActivity: ['액티비티', 'Activity', 'Activity', 'Актив'],
  styleLuxury: ['럭셔리', 'Luxury', 'Luxury', 'Люкс'],
  styleValue: ['가성비', 'Value', 'Giá tốt', 'Выгода'],
  styleLocal: ['로컬체험', 'Local experience', 'Trải nghiệm local', 'Локальный опыт'],
  styleSns: ['SNS핫플', 'SNS hotspot', 'Điểm SNS', 'Хит для SNS'],
  restrictPregnant: ['임산부 제한', 'Pregnant limited', 'Hạn chế mang thai', 'Ограничение при беременности'],
  restrictHeart: ['심장질환 주의', 'Heart caution', 'Thận trọng tim', 'Осторожно: сердце'],
  restrictWheelchair: ['휠체어 불가', 'No wheelchair', 'Không xe lăn', 'Без коляски'],
  restrictAge: ['연령제한', 'Age limit', 'Giới hạn tuổi', 'Возрастной лимит'],
  payCash: ['현금', 'Cash', 'Tiền mặt', 'Наличные'],
  payTransfer: ['계좌이체', 'Bank transfer', 'Chuyển khoản', 'Перевод'],
  payKakao: ['카카오페이', 'KakaoPay', 'Kakao Pay', 'Kakao Pay'],
  payTravelwallet: ['트래블월렛', 'Travel Wallet', 'Ví Travel Wallet', 'Кошелёк Travel Wallet'],
  payCard: ['신용카드', 'Credit card', 'Thẻ tín dụng', 'Карта'],
  simSim: ['유심 제공', 'SIM provided', 'Có SIM', 'SIM выдаётся'],
  simPocket: ['포켓WiFi 제공', 'Pocket WiFi', 'Có Pocket WiFi', 'Pocket Wi‑Fi'],
  simSharedWifi: ['공용WiFi', 'Shared WiFi', 'WiFi chung', 'Общий Wi‑Fi'],
  packPassport: ['여권', 'Passport', 'Hộ chiếu', 'Паспорт'],
  packClothes: ['긴팔/긴바지', 'Long sleeves/pants', 'Áo/quần dài', 'Длинная одежда'],
  packSwim: ['수영복', 'Swimwear', 'Đồ bơi', 'Купальник'],
  packSunscreen: ['선크림', 'Sunscreen', 'Kem chống nắng', 'Крем от солнца'],
  packShoes: ['운동화', 'Sneakers', 'Giày thể thao', 'Кроссовки'],
  packUmbrella: ['우산/우비', 'Umbrella / raincoat', 'Ô / áo mưa', 'Зонт / дождевик'],
  packCash: ['현금', 'Cash', 'Tiền mặt', 'Наличные'],
  packCamera: ['카메라', 'Camera', 'Máy ảnh', 'Камера'],
  hygieneToilet: ['화장실 이용 가능', 'Toilet available', 'Có nhà vệ sinh', 'Туалет есть'],
  hygieneShower: ['샤워 가능', 'Shower available', 'Có tắm', 'Душ есть'],
  hygieneNoToilet: ['화장실 없음 (자연/오지)', 'No toilet (nature/remote)', 'Không WC (thiên nhiên)', 'Без туалета (природа)'],
  luggageVehicle: ['차량 내 보관', 'Store in vehicle', 'Giữ trên xe', 'В машине'],
  luggageHotel: ['호텔 보관 협조', 'Hotel storage help', 'Nhờ KS giữ', 'Хранение в отеле'],
  voucherMobile: ['모바일 화면 확인', 'Show on mobile', 'Xem trên mobile', 'Показ на телефоне'],
  voucherName: ['이름 확인만 (바우처 불필요)', 'Name check only (no voucher)', 'Chỉ check tên (không voucher)', 'Только имя (без ваучера)'],
  voucherEmail: ['이메일 PDF 발송', 'Email PDF', 'Gửi PDF email', 'PDF на email'],
  fieldPassportName: ['여권 영문명', 'Passport English name', 'Tên hộ chiếu EN', 'Имя в паспорте (EN)'],
  fieldPassportNo: ['여권 번호', 'Passport number', 'Số hộ chiếu', 'Номер паспорта'],
  fieldPassportExpiry: ['여권 만료일', 'Passport expiry', 'Hạn hộ chiếu', 'Срок паспорта'],
  fieldBirthdate: ['생년월일', 'Date of birth', 'Ngày sinh', 'Дата рождения'],
  fieldHotelName: ['투숙 호텔명 (픽업용)', 'Hotel name (for pickup)', 'Tên KS (đón)', 'Отель (для трансфера)'],
  fieldHotelConfirm: ['호텔 컨펌 넘버', 'Hotel confirmation no.', 'Mã xác nhận KS', 'Номер подтверждения отеля'],
  fieldFlightNo: ['항공편명 (픽업 포함 시)', 'Flight no. (if pickup)', 'Số hiệu (nếu đón)', 'Рейс (если трансфер)'],
  fieldArrival: ['도착/출발 시간', 'Arrival / departure time', 'Giờ đến/đi', 'Прилёт / вылет'],
  fieldAllergy: ['알레르기 정보', 'Allergy info', 'Dị ứng', 'Аллергии'],
  fieldEmergency: ['비상연락처', 'Emergency contact', 'Liên hệ khẩn', 'Экстренный контакт'],
  fieldSpecial: ['특별 요청사항', 'Special requests', 'Yêu cầu đặc biệt', 'Особые пожелания'],
  // TODO: 확인 필요 — ON_SITE_EXTRA_CHIPS stored as Korean for hydrate
  onSiteFuel: ['유류할증료', 'Fuel surcharge', 'Phụ thu nhiên liệu', 'Топливный сбор'],
  onSiteDriver: ['기사 팁', 'Driver tip', 'Tip tài xế', 'Чаевые водителю'],
  onSiteGuide: ['가이드 팁', 'Guide tip', 'Tip HDV', 'Чаевые гиду'],
  onSiteAdmission: ['입장료 현장결제', 'Admission on-site', 'Vé trả tại chỗ', 'Вход на месте'],
  onSiteMeal: ['식사 추가비용', 'Extra meal cost', 'Phụ thu ăn', 'Доп. питание'],
};

const tour = {
  title: ['단품 투어 등록', 'Create tour', 'Đăng tour lẻ', 'Создать тур'],
  stepBasic: ['기본', 'Basic', 'Cơ bản', 'Основное'],
  stepPricing: ['가격', 'Pricing', 'Giá', 'Цены'],
  stepCalendar: ['달력', 'Calendar', 'Lịch', 'Календарь'],
  stepCheckPhotos: ['체크·사진', 'Checklist & photos', 'Checklist & ảnh', 'Чеклист и фото'],
  duration2h: ['2시간', '2 hours', '2 giờ', '2 часа'],
  durationHalf: ['반일', 'Half day', 'Nửa ngày', 'Полдня'],
  durationFull: ['종일', 'Full day', 'Cả ngày', 'Целый день'],
  name: ['투어명', 'Tour name', 'Tên tour', 'Название тура'],
  duration: ['소요 시간', 'Duration', 'Thời lượng', 'Длительность'],
  meeting: ['미팅 장소', 'Meeting point', 'Điểm hẹn', 'Место встречи'],
  meetingPh: [
    '예: 미케 비치 정문',
    'e.g. My Khe Beach main gate',
    'vd: Cổng chính My Khe',
    'напр. главный вход My Khe',
  ],
  languages: ['언어 지원', 'Languages', 'Ngôn ngữ', 'Языки'],
  departureTime: ['출발 시간', 'Departure time', 'Giờ khởi hành', 'Время выезда'],
  addTime: ['시간 추가', 'Add time', 'Thêm giờ', 'Добавить время'],
  pickup: ['픽업 제공', 'Pickup provided', 'Có đón', 'Есть трансфер'],
  pickupPlace: ['픽업 지역', 'Pickup area', 'Khu vực đón', 'Зона трансфера'],
  adult: ['성인 요금', 'Adult price', 'Giá người lớn', 'Цена взрослого'],
  child: ['아동 요금', 'Child price', 'Giá trẻ em', 'Цена ребёнка'],
  infant: ['유아 요금', 'Infant price', 'Giá trẻ nhỏ', 'Цена младенца'],
  minGuests: ['최소 인원', 'Min guests', 'Tối thiểu', 'Мин. гостей'],
  maxGuests: ['최대 인원', 'Max guests', 'Tối đa', 'Макс. гостей'],
  currency: ['통화', 'Currency', 'Tiền tệ', 'Валюта'],
  bookingInstant: ['즉시예약', 'Instant book', 'Đặt ngay', 'Мгновенно'],
  bookingConfirm: ['확인 후 예약', 'Confirm then book', 'Xác nhận rồi đặt', 'После подтверждения'],
  cancellation: ['취소 정책', 'Cancellation', 'Chính sách hủy', 'Отмена'],
  defaultTitle: ['새 투어', 'New tour', 'Tour mới', 'Новый тур'],
  toastPublished: [
    '투어가 게시됐어요!',
    'Tour published!',
    'Đã đăng tour!',
    'Тур опубликован!',
  ],
};

const accommodation = {
  titleLock: [
    '숙소 상품은 유료 플랜에서 사용할 수 있어요',
    'Stays require a paid plan',
    'Lưu trú cần gói trả phí',
    'Жильё доступно на платном плане',
  ],
  titleForm: ['숙소 등록', 'Create stay', 'Đăng lưu trú', 'Создать жильё'],
  planLock: [
    '숙소는 유료 플랜에서 등록할 수 있어요',
    'Stays can be listed on paid plans',
    'Lưu trú đăng được trên gói trả phí',
    'Жильё можно размещать на платном плане',
  ],
  stepBasic: ['기본', 'Basic', 'Cơ bản', 'Основное'],
  stepRooms: ['객실', 'Rooms', 'Phòng', 'Номера'],
  stepCalendar: ['달력', 'Calendar', 'Lịch', 'Календарь'],
  stepPhotos: ['사진·정책', 'Photos & policy', 'Ảnh & chính sách', 'Фото и правила'],
  name: ['숙소명', 'Property name', 'Tên chỗ ở', 'Название'],
  type: ['숙소 유형', 'Property type', 'Loại chỗ ở', 'Тип жилья'],
  address: ['주소', 'Address', 'Địa chỉ', 'Адрес'],
  checkIn: ['체크인', 'Check-in', 'Nhận phòng', 'Заезд'],
  checkOut: ['체크아웃', 'Check-out', 'Trả phòng', 'Выезд'],
  stars: ['성급', 'Star rating', 'Hạng sao', 'Звёзды'],
  typeHotel: ['호텔', 'Hotel', 'Khách sạn', 'Отель'],
  typeResort: ['리조트', 'Resort', 'Resort', 'Курорт'],
  typeVilla: ['빌라', 'Villa', 'Villa', 'Вилла'],
  typeHomestay: ['홈스테이', 'Homestay', 'Homestay', 'Хоумстей'],
  starN: ['{n}성', '{n}-star', '{n} sao', '{n}*'],
  roomName: ['객실명', 'Room name', 'Tên phòng', 'Название номера'],
  baseGuests: ['기준 인원', 'Base guests', 'Số khách cơ bản', 'Базовые гости'],
  maxGuests: ['최대 인원', 'Max guests', 'Tối đa', 'Макс. гостей'],
  addRoom: ['객실 추가', 'Add room', 'Thêm phòng', 'Добавить номер'],
  weekdayPrice: ['평일 요금', 'Weekday rate', 'Giá ngày thường', 'Цена будни'],
  weekendPrice: ['주말 요금', 'Weekend rate', 'Giá cuối tuần', 'Цена выходных'],
  breakfast: ['조식 포함', 'Breakfast included', 'Gồm bữa sáng', 'Завтрак включён'],
  cancellation: ['취소 정책', 'Cancellation', 'Chính sách hủy', 'Отмена'],
  defaultTitle: ['새 숙소', 'New stay', 'Chỗ ở mới', 'Новое жильё'],
  toastPublished: [
    '숙소가 게시됐어요!',
    'Stay published!',
    'Đã đăng lưu trú!',
    'Жильё опубликовано!',
  ],
  amenityWifi: ['WiFi', 'WiFi', 'WiFi', 'WiFi'],
  amenityAc: ['에어컨', 'A/C', 'Máy lạnh', 'Кондиционер'],
  amenityTv: ['TV', 'TV', 'TV', 'TV'],
  amenityFridge: ['냉장고', 'Fridge', 'Tủ lạnh', 'Холодильник'],
  amenityTub: ['욕조', 'Bathtub', 'Bồn tắm', 'Ванна'],
  amenityBalcony: ['발코니', 'Balcony', 'Ban công', 'Балкон'],
  amenityPool: ['수영장', 'Pool', 'Hồ bơi', 'Бассейн'],
  amenityBreakfast: ['조식', 'Breakfast', 'Bữa sáng', 'Завтрак'],
};

const service = {
  section: ['서비스', 'Service', 'Dịch vụ', 'Услуга'],
  title: ['서비스명 *', 'Service name *', 'Tên dịch vụ *', 'Название услуги *'],
  titlePh: [
    '예: 한국어 통역 서비스, 베트남 마사지',
    'e.g. Korean interpretation, Vietnam massage',
    'vd: Thông dịch tiếng Hàn, massage Việt',
    'напр. корейский перевод, массаж во Вьетнаме',
  ],
  desc: ['서비스 설명', 'Description', 'Mô tả dịch vụ', 'Описание'],
  descPh: [
    '서비스 내용, 특징, 주의사항 등을 입력해주세요.',
    'Describe the service, features, and notes.',
    'Nhập nội dung, điểm nổi bật, lưu ý…',
    'Опишите услугу, особенности и замечания.',
  ],
  duration: ['소요 시간', 'Duration', 'Thời lượng', 'Длительность'],
  durationPh: ['예: 90', 'e.g. 90', 'vd: 90', 'напр. 90'],
  durationUnit: ['분', 'min', 'phút', 'мин'],
  price: ['가격', 'Price', 'Giá', 'Цена'],
  languages: ['지원 언어', 'Languages', 'Ngôn ngữ hỗ trợ', 'Языки'],
  photos: ['사진', 'Photos', 'Hình ảnh', 'Фото'],
  slotCapacity: [
    '동시 예약 가능 인원 (시간대별 정원)',
    'Concurrent bookings per time slot',
    'Số khách tối đa mỗi khung giờ',
    'Мест на один временной слот',
  ],
  slotCapacityPh: ['예: 2 (비우면 무제한)', 'e.g. 2 (blank = unlimited)', 'vd: 2 (để trống = không giới hạn)', 'напр. 2 (пусто = без ограничений)'],
  slotCapacityHint: [
    '같은 날짜·시간에 이 인원만큼만 예약을 받습니다. 비워두면 예약 요청을 다 받고 채팅으로 직접 조율해요.',
    'Only this many bookings are accepted for the same date and time. Leave blank to accept all requests and coordinate by chat.',
    'Chỉ nhận số lượng đặt chỗ này cho cùng ngày và giờ. Để trống để nhận mọi yêu cầu và trao đổi qua chat.',
    'На одну дату и время принимается не больше этого числа броней. Оставьте пустым, чтобы принимать все заявки и договариваться в чате.',
  ],
  listPrice: ['정가 (할인 전 가격)', 'Original price (before discount)', 'Giá gốc (trước giảm giá)', 'Исходная цена (до скидки)'],
  listPricePh: ['예: 정가가 더 높으면 할인율이 자동 표시돼요', 'e.g. set higher than price to show a discount badge', 'vd: đặt cao hơn giá bán để hiện huy hiệu giảm giá', 'напр. укажите выше цены продажи для показа скидки'],
  listPriceHint: [
    '판매가보다 높게 입력하면 허브 화면에 할인율(%) 배지가 자동으로 뜹니다. 비워두면 할인 표시 없이 판매가만 노출돼요.',
    'Set this higher than the price above to auto-show a discount % badge on hub listings. Leave blank to show no discount.',
    'Đặt cao hơn giá bán để tự động hiện huy hiệu giảm giá (%) trên trang hub. Để trống để không hiện giảm giá.',
    'Укажите выше цены продажи, чтобы автоматически показать бейдж скидки (%) в разделе хаба. Оставьте пустым, чтобы не показывать скидку.',
  ],
  isPopularToggle: ['🔥 인기 서비스로 표시', '🔥 Mark as popular', '🔥 Đánh dấu phổ biến', '🔥 Отметить как популярное'],
  isPopularHint: [
    '허브 상단 캐러셀에 우선 노출돼요. 예약이 몰리는 시간대 홍보에 활용해보세요.',
    'Shown first in the hub carousel. Useful for promoting busy time slots.',
    'Hiển thị ưu tiên trên carousel đầu trang hub. Hữu ích để quảng bá khung giờ đông khách.',
    'Показывается первым в карусели хаба. Полезно для продвижения загруженных слотов.',
  ],
  timeDiscount: {
    section: ['시간대 할인', 'Time-based discount', 'Giảm giá theo khung giờ', 'Скидка по времени'],
    sectionHint: [
      '특정 요일·시간에 예약하면 자동으로 할인가가 적용돼요. 한가한 시간대를 채우는 데 활용해보세요.',
      'Bookings in a chosen day/time window get the discounted price automatically. Great for filling off-peak slots.',
      'Đặt chỗ trong khung ngày/giờ đã chọn sẽ tự động được áp giá giảm. Hữu ích để lấp đầy giờ vắng khách.',
      'Брони в выбранный день/время автоматически получают скидку. Удобно для заполнения непопулярных часов.',
    ],
    needSaveFirst: [
      '먼저 저장(임시저장도 가능)한 뒤에 할인 규칙을 추가할 수 있어요.',
      'Save the service first (a draft is fine) before adding discount rules.',
      'Hãy lưu dịch vụ trước (kể cả bản nháp) rồi mới thêm quy tắc giảm giá.',
      'Сначала сохраните услугу (можно как черновик), затем добавляйте правила скидок.',
    ],
    empty: ['등록된 시간대 할인이 없어요', 'No time discounts yet', 'Chưa có giảm giá theo khung giờ', 'Скидок по времени пока нет'],
    addBtn: ['+ 할인 규칙 추가', '+ Add discount rule', '+ Thêm quy tắc giảm giá', '+ Добавить правило скидки'],
    edit: ['수정', 'Edit', 'Sửa', 'Изменить'],
    delete: ['삭제', 'Delete', 'Xóa', 'Удалить'],
    daysLabel: ['적용 요일', 'Days', 'Ngày áp dụng', 'Дни'],
    startLabel: ['시작 시간', 'Start time', 'Giờ bắt đầu', 'Начало'],
    endLabel: ['종료 시간', 'End time', 'Giờ kết thúc', 'Окончание'],
    typeLabel: ['할인 방식', 'Discount type', 'Hình thức giảm giá', 'Тип скидки'],
    typePercent: ['정률(%)', 'Percent (%)', 'Theo %', 'Процент (%)'],
    typeAmount: ['정액', 'Fixed amount', 'Số tiền cố định', 'Фиксированная сумма'],
    valuePercentLabel: ['할인율 (%)', 'Discount (%)', 'Tỷ lệ giảm (%)', 'Скидка (%)'],
    valueAmountLabel: ['할인 금액', 'Discount amount', 'Số tiền giảm', 'Сумма скидки'],
    labelLabel: ['규칙 이름 (선택)', 'Rule name (optional)', 'Tên quy tắc (tùy chọn)', 'Название правила (необязательно)'],
    labelPh: ['예: 평일 오후 한가한 시간', 'e.g. Weekday quiet hours', 'vd: Giờ vắng khách ngày thường', 'напр. Тихие часы в будни'],
    saveBtn: ['저장', 'Save', 'Lưu', 'Сохранить'],
    percentValue: ['{n}% 할인', '{n}% off', 'Giảm {n}%', 'Скидка {n}%'],
    amountValue: ['{n} 할인', '{n} off', 'Giảm {n}', 'Скидка {n}'],
    inactive: ['꺼짐', 'Off', 'Đã tắt', 'Отключено'],
    day0: ['일', 'Sun', 'CN', 'Вс'],
    day1: ['월', 'Mon', 'T2', 'Пн'],
    day2: ['화', 'Tue', 'T3', 'Вт'],
    day3: ['수', 'Wed', 'T4', 'Ср'],
    day4: ['목', 'Thu', 'T5', 'Чт'],
    day5: ['금', 'Fri', 'T6', 'Пт'],
    day6: ['토', 'Sat', 'T7', 'Сб'],
  },
  combo: {
    section: ['콤보 상품', 'Combo bundle', 'Gói combo', 'Комбо-набор'],
    sectionHint: [
      '이미 등록된 다른 서비스들을 묶어서 하나의 예약 가능한 상품으로 팝니다 (예: 마사지+네일 세트).',
      'Bundle other already-registered services into one bookable item (e.g. massage + nail set).',
      'Kết hợp các dịch vụ đã đăng thành một sản phẩm có thể đặt (vd: combo mát-xa + làm nail).',
      'Объедините уже добавленные услуги в один бронируемый товар (напр. массаж + маникюр).',
    ],
    toggle: ['🎁 콤보 상품으로 만들기', '🎁 Make this a combo', '🎁 Tạo thành combo', '🎁 Сделать комбо-набором'],
    pickerTitle: ['포함할 서비스 선택', 'Select included services', 'Chọn dịch vụ trong combo', 'Выберите услуги в наборе'],
    pickerEmpty: [
      '묶을 수 있는 다른 서비스가 없어요. 먼저 다른 서비스를 등록해 주세요.',
      'No other services to bundle yet. Register another service first.',
      'Chưa có dịch vụ khác để ghép. Hãy đăng dịch vụ khác trước.',
      'Пока нет других услуг для объединения. Сначала добавьте ещё одну услугу.',
    ],
    pickerHint: [
      '2개 이상 선택하면 콤보로 저장돼요. 가격은 위 "가격" 필드에 직접 입력한 콤보 가격이 적용됩니다.',
      'Pick 2 or more to save as a combo. The price above is the combined bundle price you set.',
      'Chọn từ 2 dịch vụ trở lên để lưu thành combo. Giá ở trên là giá combo bạn tự đặt.',
      'Выберите 2 и более, чтобы сохранить как комбо. Указанная выше цена — это цена набора.',
    ],
    totalDuration: [
      '선택한 서비스 총 소요시간: {time}',
      'Total duration of selected services: {time}',
      'Tổng thời lượng dịch vụ đã chọn: {time}',
      'Общая длительность выбранных услуг: {time}',
    ],
    applyDuration: ['이 값으로 채우기', 'Apply this value', 'Áp dụng giá trị này', 'Применить это значение'],
    listPriceAuto: [
      '포함된 서비스들의 가격을 더한 값이에요. 위 "가격"에 입력한 콤보 판매가와 비교해서 할인율이 자동으로 표시됩니다.',
      'This is the sum of the included services’ prices. The discount % is calculated automatically against the combo price above.',
      'Đây là tổng giá của các dịch vụ được bao gồm. Tỷ lệ giảm giá được tính tự động so với giá combo ở trên.',
      'Это сумма цен включённых услуг. Процент скидки рассчитывается автоматически по сравнению с ценой комбо выше.',
    ],
    photosAutoHint: [
      '콤보는 포함된 서비스들의 사진을 자동으로 모아서 보여줘요. 따로 사진을 올릴 필요 없어요.',
      'Combo photos are automatically gathered from the included services — no separate upload needed.',
      'Ảnh combo được tự động lấy từ các dịch vụ bao gồm — không cần tải ảnh riêng.',
      'Фото комбо автоматически берутся из включённых услуг — отдельная загрузка не нужна.',
    ],
  },
  cancel: ['취소', 'Cancel', 'Hủy', 'Отмена'],
  needTitle: [
    '서비스명을 입력해 주세요',
    'Please enter a service name',
    'Vui lòng nhập tên dịch vụ',
    'Введите название услуги',
  ],
};

const simPlan = {
  sectionBasic: ['기본 정보', 'Basic info', 'Thông tin cơ bản', 'Основная информация'],
  title: ['상품명', 'Product name', 'Tên sản phẩm', 'Название товара'],
  titlePh: [
    '예: 5G 이심 7일권, 포켓와이파이 대여',
    'e.g. 5G eSIM 7-day plan, pocket wifi rental',
    'vd: gói eSIM 5G 7 ngày, thuê wifi di động',
    'напр. eSIM 5G на 7 дней, аренда карманного wifi',
  ],
  desc: ['상품 설명', 'Description', 'Mô tả sản phẩm', 'Описание'],
  descPh: [
    '수령 방법, 개통 방법, 주의사항 등을 입력해주세요.',
    'Describe how to receive and activate it, plus any notes.',
    'Nhập cách nhận hàng, cách kích hoạt, lưu ý…',
    'Опишите способ получения, активации и другие детали.',
  ],
  simForm: ['상품 형태', 'Product type', 'Loại sản phẩm', 'Тип продукта'],
  carrier: ['통신사', 'Carrier', 'Nhà mạng', 'Оператор'],
  carrierOther: ['기타', 'Other', 'Khác', 'Другое'],
  deliveryMethod: ['수령 방법', 'Delivery method', 'Cách nhận hàng', 'Способ получения'],
  networkType: ['네트워크', 'Network', 'Mạng', 'Сеть'],
  networkTypePh: ['예: 4G/5G', 'e.g. 4G/5G', 'vd: 4G/5G', 'напр. 4G/5G'],
  currency: ['통화', 'Currency', 'Tiền tệ', 'Валюта'],
  photos: ['사진', 'Photos', 'Ảnh', 'Фото'],
  sectionPlans: ['요금제 등록', 'Plan options', 'Các gói cước', 'Тарифные планы'],
  plansHint: [
    '유효기간·데이터용량 조합별로 행을 추가하세요. 고객은 상세페이지에서 원하는 조합을 골라요.',
    'Add a row per validity/data combo — customers pick the combo they want on the detail page.',
    'Thêm từng dòng theo tổ hợp thời hạn/dung lượng — khách sẽ chọn tổ hợp mong muốn ở trang chi tiết.',
    'Добавьте строку для каждой комбинации срок/объём — клиент выбирает нужную комбинацию на странице товара.',
  ],
  colValidity: ['유효기간(일)', 'Validity (days)', 'Thời hạn (ngày)', 'Срок (дней)'],
  colData: ['데이터', 'Data', 'Dung lượng', 'Данные'],
  colPrice: ['가격', 'Price', 'Giá', 'Цена'],
  daysPh: ['일수', 'Days', 'Số ngày', 'Дней'],
  unlimited: ['무제한', 'Unlimited', 'Không giới hạn', 'Безлимит'],
  removeRow: ['삭제', 'Remove', 'Xóa', 'Удалить'],
  addRow: ['요금제 추가', 'Add plan', 'Thêm gói', 'Добавить тариф'],
  cancel: ['취소', 'Cancel', 'Hủy', 'Отмена'],
  needTitle: [
    '상품명을 입력해 주세요',
    'Please enter a product name',
    'Vui lòng nhập tên sản phẩm',
    'Введите название товара',
  ],
  needOneRow: [
    '요금제를 최소 1개 이상 입력해 주세요 (유효기간·데이터·가격)',
    'Please add at least one plan (validity, data, price)',
    'Vui lòng thêm ít nhất 1 gói (thời hạn, dung lượng, giá)',
    'Добавьте хотя бы один тариф (срок, объём, цена)',
  ],
};

const simFormOptions = {
  esim: ['이심(eSIM)', 'eSIM', 'eSIM (sim điện tử)', 'eSIM (электронная SIM)'],
  physical_sim: ['유심(실물 SIM)', 'Physical SIM', 'SIM vật lý', 'Физическая SIM'],
  pocket_wifi: ['포켓와이파이', 'Pocket wifi', 'Wifi di động', 'Карманный wifi'],
};

const deliveryOptions = {
  qr_instant: ['QR코드 즉시발급', 'Instant QR code', 'Mã QR tức thì', 'QR-код мгновенно'],
  airport_counter: ['공항 카운터 수령', 'Airport counter pickup', 'Nhận tại quầy sân bay', 'Получение в аэропорту'],
  store_pickup: ['매장 방문 수령', 'Store pickup', 'Nhận tại cửa hàng', 'Получение в магазине'],
};

const menu = {
  title: ['메뉴 등록', 'Add menu item', 'Đăng món', 'Добавить блюдо'],
  productTitle: ['상품 등록', 'Add product', 'Đăng sản phẩm', 'Добавить товар'],
  stepBasic: ['기본', 'Basic', 'Cơ bản', 'Основное'],
  stepPricing: ['가격', 'Pricing', 'Giá', 'Цены'],
  stepDetail: ['상세', 'Details', 'Chi tiết', 'Детали'],
  stepPhotos: ['사진', 'Photos', 'Ảnh', 'Фото'],
  defaultTitle: ['새 메뉴', 'New menu item', 'Món mới', 'Новое блюдо'],
  productDefaultTitle: ['새 상품', 'New product', 'Sản phẩm mới', 'Новый товар'],
  name: ['메뉴명', 'Menu name', 'Tên món', 'Название блюда'],
  productName: ['상품명', 'Product name', 'Tên sản phẩm', 'Название товара'],
  namePh: [
    '예: 소고기 쌀국수',
    'e.g. Beef pho',
    'vd: Phở bò',
    'напр. Фо с говядиной',
  ],
  cafeNamePh: [
    '예: 아이스 아메리카노, 카페라떼',
    'e.g. Iced Americano, Cafe latte',
    'vd: Americano đá, Cafe latte',
    'напр. Айс американо, Латте',
  ],
  productNamePh: [
    '예: 신라면 5개입, 바나나 1kg',
    'e.g. Instant noodles 5-pack, Bananas 1kg',
    'vd: Mì gói 5 cái, Chuối 1kg',
    'напр. Лапша 5 шт, Бананы 1 кг',
  ],
  category: ['카테고리', 'Category', 'Danh mục', 'Категория'],
  categoryHint: [
    '메뉴 이름도, 업소 장르(한식·피자 등)도 아니에요. 이 매장 메뉴판을 보기 좋게 묶는 그룹이에요 (예: 메인메뉴, 사이드, 음료)',
    "Not the dish name or the store's overall genre (Korean, Pizza, etc.) — this groups your own menu items for display (e.g. Main, Side, Drinks)",
    'Không phải tên món, cũng không phải thể loại quán (Hàn Quốc, Pizza...) — đây là nhóm để sắp xếp thực đơn của bạn (vd: Món chính, Món phụ, Đồ uống)',
    'Это не название блюда и не жанр заведения (корейская кухня, пицца и т.д.) — это группа для оформления вашего меню (напр. Основное, Гарнир, Напитки)',
  ],
  cafeCategoryHint: [
    '메뉴판을 보기 좋게 묶는 그룹이에요 (예: 커피, 음료, 디저트, 베이커리)',
    'Groups items on your cafe menu (e.g. Coffee, Drinks, Dessert, Bakery)',
    'Nhóm món trên thực đơn quán (vd: Cà phê, Đồ uống, Tráng miệng, Bánh)',
    'Группы позиций в меню кафе (напр. Кофе, Напитки, Десерт, Выпечка)',
  ],
  productCategoryHint: [
    '매장 진열·목록을 보기 좋게 묶는 분류예요 (예: 라면·면, 음료, 생활용품)',
    'Groups products for your store list (e.g. Noodles, Drinks, Household)',
    'Nhóm sản phẩm trên danh sách cửa hàng (vd: Mì, Đồ uống, Đồ gia dụng)',
    'Группы товаров в витрине (напр. Лапша, Напитки, Бытовые товары)',
  ],
  categoryEmpty: [
    '아직 만든 카테고리가 없어요. 아래에서 추가해보세요.',
    "You haven't created any categories yet. Add one below.",
    'Chưa có danh mục nào. Thêm ở bên dưới.',
    'Категорий пока нет. Добавьте ниже.',
  ],
  categorySuggestHint: [
    '자주 쓰는 분류예요. 눌러서 바로 추가해보세요',
    'Common categories — tap to add instantly',
    'Danh mục thường dùng — chạm để thêm ngay',
    'Частые категории — нажмите, чтобы добавить сразу',
  ],
  categoryAddPlaceholder: ['새 카테고리 이름 (예: 메인메뉴)', 'New category (e.g. Main)', 'Danh mục mới (vd: Món chính)', 'Новая категория (напр. Основное)'],
  cafeCategoryAddPlaceholder: [
    '새 카테고리 이름 (예: 커피)',
    'New category (e.g. Coffee)',
    'Danh mục mới (vd: Cà phê)',
    'Новая категория (напр. Кофе)',
  ],
  productCategoryAddPlaceholder: [
    '새 카테고리 이름 (예: 라면·면)',
    'New category (e.g. Noodles)',
    'Danh mục mới (vd: Mì)',
    'Новая категория (напр. Лапша)',
  ],
  categoryAddBtn: ['카테고리 추가', 'Add category', 'Thêm danh mục', 'Добавить категорию'],
  categoryAdding: ['추가 중…', 'Adding…', 'Đang thêm…', 'Добавление…'],
  categoryAddFail: ['카테고리 추가에 실패했어요', 'Failed to add category', 'Thêm danh mục thất bại', 'Не удалось добавить категорию'],
  categoryMain: ['메인메뉴', 'Main', 'Món chính', 'Основное'],
  categorySide: ['사이드', 'Side', 'Món phụ', 'Гарнир'],
  categorySoup: ['국물/찌개', 'Soup', 'Món canh', 'Суп'],
  categoryCoffee: ['커피', 'Coffee', 'Cà phê', 'Кофе'],
  categoryDrink: ['음료', 'Drinks', 'Đồ uống', 'Напитки'],
  categoryDessert: ['디저트', 'Dessert', 'Tráng miệng', 'Десерт'],
  categoryBakery: ['베이커리', 'Bakery', 'Bánh', 'Выпечка'],
  categorySet: ['세트', 'Set', 'Set', 'Сет'],
  description: ['메뉴 설명', 'Description', 'Mô tả món', 'Описание'],
  productDescription: ['상품 설명', 'Product description', 'Mô tả sản phẩm', 'Описание товара'],
  descriptionPh: [
    '재료, 맛, 특징 등을 입력해주세요',
    'Describe ingredients, taste, highlights',
    'Nhập nguyên liệu, hương vị, điểm nổi bật',
    'Опишите ингредиенты, вкус, особенности',
  ],
  cafeDescriptionPh: [
    '원두, 로스팅, 맛·특징 등을 입력해주세요',
    'Describe beans, roast, taste highlights',
    'Nhập hạt, rang, hương vị nổi bật',
    'Опишите зёрна, обжарку, вкус',
  ],
  productDescriptionPh: [
    '용량, 브랜드, 특징 등을 입력해주세요',
    'Describe size, brand, key features',
    'Nhập dung tích, thương hiệu, điểm nổi bật',
    'Опишите объём, бренд, особенности',
  ],
  basePrice: ['가격', 'Price', 'Giá', 'Цена'],
  sizes: ['사이즈 옵션', 'Size options', 'Tùy chọn size', 'Варианты размера'],
  productSizes: ['용량·규격 옵션', 'Size / pack options', 'Tùy chọn dung tích', 'Варианты объёма'],
  sizesHint: [
    '사이즈별로 다른 가격이 있다면 추가하세요 (선택)',
    'Add different prices per size (optional)',
    'Thêm giá khác nhau theo size (tuỳ chọn)',
    'Добавьте цены по размерам (опционально)',
  ],
  cafeSizesHint: [
    'S / M / L처럼 사이즈별 가격이 다르면 추가하세요 (선택)',
    'Add S / M / L prices if they differ (optional)',
    'Thêm giá S / M / L nếu khác nhau (tuỳ chọn)',
    'Добавьте цены S / M / L, если отличаются (опционально)',
  ],
  productSizesHint: [
    '용량·팩 단위별로 가격이 다르면 추가하세요 (선택)',
    'Add prices for different pack sizes (optional)',
    'Thêm giá theo dung tích/gói (tuỳ chọn)',
    'Добавьте цены для разных фасовок (опционально)',
  ],
  sizeNamePh: ['예: L 사이즈', 'e.g. Large', 'vd: Size L', 'напр. Большой'],
  cafeSizeNamePh: ['예: S, M, L', 'e.g. S, M, L', 'vd: S, M, L', 'напр. S, M, L'],
  productSizeNamePh: ['예: 500ml, 1.5L', 'e.g. 500ml, 1.5L', 'vd: 500ml, 1.5L', 'напр. 500 мл, 1,5 л'],
  sizePricePh: ['추가 가격', 'Extra price', 'Giá thêm', 'Доп. цена'],
  removeSize: ['사이즈 삭제', 'Remove size', 'Xóa size', 'Удалить размер'],
  addSize: ['사이즈 추가', 'Add size', 'Thêm size', 'Добавить размер'],
  productAddSize: ['규격 추가', 'Add pack size', 'Thêm quy cách', 'Добавить фасовку'],
  promoSectionTitle: ['할인·인기 표시', 'Discount & popular tag', 'Giảm giá & thẻ phổ biến', 'Скидка и тег «Популярное»'],
  promoSectionExplain: [
    '아래에서 설정하면 고객이 보는 목록 화면에 바로 반영돼요. 오른쪽 미리보기로 실시간 확인하세요.',
    'What you set below shows up immediately on the customer list screen. Check the live preview on the right.',
    'Những gì bạn thiết lập bên dưới sẽ hiển thị ngay trên màn hình danh sách của khách hàng. Xem trước trực tiếp bên phải.',
    'То, что вы настроите ниже, сразу отразится на экране списка для клиентов. Смотрите предпросмотр справа.',
  ],
  listPrice: ['할인 전 가격 (선택)', 'Original price (optional)', 'Giá gốc (tuỳ chọn)', 'Цена до скидки (опционально)'],
  listPriceHint: [
    '위 가격보다 높게 입력하면, 고객 화면에서 이 가격에 취소선이 그어지고 할인율(%) 배지가 자동으로 붙어요. 비워두면 할인 표시 없이 일반 가격으로만 보여요.',
    'Enter a value higher than the price above and the customer screen will strike it through and add a discount % badge automatically. Leave blank to show a plain price with no discount badge.',
    'Nhập giá cao hơn giá ở trên, màn hình khách hàng sẽ gạch ngang giá này và tự động gắn nhãn giảm giá (%). Để trống nếu không muốn hiển thị giảm giá.',
    'Введите значение выше указанной цены — на экране клиента оно будет зачёркнуто, и автоматически появится значок скидки (%). Оставьте пустым, чтобы показать обычную цену без скидки.',
  ],
  isPopularToggle: ['인기 배지', 'Popular badge', 'Huy hiệu phổ biến', 'Значок «Популярное»'],
  productIsPopularToggle: ['인기 상품 배지', 'Popular product badge', 'Huy hiệu sản phẩm phổ biến', 'Значок популярного товара'],
  isPopularHint: [
    '실제 주문량을 기준으로 자동으로 부여돼요. 업체가 직접 켤 수 없어요.',
    'This badge is assigned automatically based on real order volume. It can’t be turned on manually.',
    'Huy hiệu này được gắn tự động dựa trên số lượng đơn hàng thực tế. Cửa hàng không thể tự bật.',
    'Этот значок присваивается автоматически на основе реального объёма заказов. Включить его вручную нельзя.',
  ],
  isPopularBadgeOn: [
    '현재 인기 배지가 적용되어 있어요',
    'This item currently has the popular badge',
    'Món này hiện đang có huy hiệu phổ biến',
    'Сейчас у этого товара есть значок «Популярное»',
  ],
  isPopularBadgeOff: [
    '아직 인기 배지가 없어요',
    'No popular badge yet',
    'Chưa có huy hiệu phổ biến',
    'Пока нет значка «Популярное»',
  ],
  isFeaturedToggle: ['추천 강조 표시', 'Recommended highlight', 'Đánh dấu đề xuất', 'Отметка «рекомендуем»'],
  isFeaturedHint: [
    '켜면 카드에 "추천" 표시가 붙어요. 무료 기능이라 목록 순위에는 영향을 주지 않아요 — 실제 상단 노출은 광고 탭의 유료 슬롯을 이용해 주세요.',
    'Turning this on adds a "Recommended" label to the card. This is a free feature and does not affect list ranking — for actual top placement, use the paid slot in the Ads tab.',
    'Khi bật, món sẽ có nhãn "Đề xuất". Đây là tính năng miễn phí nên không ảnh hưởng thứ hạng — để lên đầu danh sách thật, hãy dùng slot trả phí ở tab Quảng cáo.',
    'При включении на карточке появится метка «Рекомендуем». Это бесплатная функция и она не влияет на позицию в списке — для реального верхнего размещения используйте платный слот на вкладке «Реклама».',
  ],
  previewLabel: ['고객 화면 미리보기', 'Customer screen preview', 'Xem trước màn hình khách hàng', 'Предпросмотр экрана клиента'],
  previewTitlePlaceholder: ['메뉴 이름을 입력하세요', 'Enter a menu name', 'Nhập tên món', 'Введите название меню'],
  productPreviewTitlePlaceholder: [
    '상품 이름을 입력하세요',
    'Enter a product name',
    'Nhập tên sản phẩm',
    'Введите название товара',
  ],
  previewBusinessPlaceholder: ['내 업체', 'My business', 'Cửa hàng của tôi', 'Мой бизнес'],
  optionGroups: ['옵션/토핑', 'Options / toppings', 'Tùy chọn / topping', 'Опции / топпинги'],
  cafeOptionGroups: ['옵션', 'Options', 'Tùy chọn', 'Опции'],
  optionGroupsHint: [
    '고객이 고를 수 있는 옵션(예: 맵기, 토핑)을 추가하세요 (선택)',
    'Add options customers can pick (e.g. spice level, toppings) — optional',
    'Thêm tùy chọn khách có thể chọn (vd: độ cay, topping) — tuỳ chọn',
    'Добавьте опции для выбора (напр. острота, топпинги) — по желанию',
  ],
  cafeOptionGroupsHint: [
    '샷·시럽처럼 고객이 고를 옵션을 추가하고, 선택지 옆 추가 금액에 가격을 넣으면 주문 합계에 더해져요',
    'Add options like shot or syrup — enter an extra amount next to each choice and it adds to the order total',
    'Thêm tùy chọn như shot, syrup — nhập số tiền thêm cạnh lựa chọn để cộng vào tổng đơn',
    'Добавьте опции (шот, сироп) — сумма рядом с вариантом прибавится к заказу',
  ],
  optionGroupNamePh: [
    '옵션 그룹 이름 (예: 토핑 추가)',
    'Option group name (e.g. Extra toppings)',
    'Tên nhóm tùy chọn (vd: Thêm topping)',
    'Название группы опций (напр. Доп. топпинги)',
  ],
  cafeOptionGroupNamePh: [
    '옵션 그룹 이름 (예: 샷 추가)',
    'Option group name (e.g. Extra shot)',
    'Tên nhóm tùy chọn (vd: Thêm shot)',
    'Название группы опций (напр. Доп. шот)',
  ],
  removeOptionGroup: ['옵션 그룹 삭제', 'Remove option group', 'Xóa nhóm tùy chọn', 'Удалить группу опций'],
  optionTypeSingle: ['1개만 선택', 'Pick one', 'Chọn 1', 'Выбрать одно'],
  optionTypeMulti: ['여러 개 선택 가능', 'Pick multiple', 'Chọn nhiều', 'Выбрать несколько'],
  optionRequiredToggle: ['필수 선택', 'Required', 'Bắt buộc', 'Обязательно'],
  optionChoiceNamePh: ['선택지 이름 (예: 치즈 추가)', 'Choice name (e.g. Extra cheese)', 'Tên lựa chọn (vd: Thêm phô mai)', 'Название варианта (напр. Доп. сыр)'],
  cafeOptionChoiceNamePh: [
    '선택지 이름 (예: 샷 1개 추가)',
    'Choice name (e.g. +1 shot)',
    'Tên lựa chọn (vd: +1 shot)',
    'Название варианта (напр. +1 шот)',
  ],
  optionChoicePricePh: ['추가 가격', 'Extra price', 'Giá thêm', 'Доп. цена'],
  cafeOptionChoicePricePh: [
    '추가 금액 (예: 3000)',
    'Extra amount (e.g. 3000)',
    'Số tiền thêm (vd: 3000)',
    'Доп. сумма (напр. 3000)',
  ],
  cafeOptionPriceHint: [
    '선택지 오른쪽 칸 = 추가 금액이에요. 비우면 무료, 숫자를 넣으면 그 금액이 주문에 합산됩니다.',
    'The right field is the extra charge. Leave blank for free; enter a number to add it to the order total.',
    'Ô bên phải là phí thêm. Để trống = miễn phí; nhập số thì cộng vào tổng đơn.',
    'Правое поле — доплата. Пусто = бесплатно; число прибавится к сумме заказа.',
  ],
  cafePresetShot: ['+ 샷 추가 (유료)', '+ Extra shot (paid)', '+ Thêm shot (tính phí)', '+ Доп. шот (платно)'],
  cafePresetShotGroup: ['샷 추가', 'Extra shot', 'Thêm shot', 'Доп. шот'],
  cafePresetShot1: ['샷 1개 추가', '+1 shot', 'Thêm 1 shot', '+1 шот'],
  cafePresetShot2: ['샷 2개 추가', '+2 shots', 'Thêm 2 shot', '+2 шота'],
  cafePresetSyrup: ['+ 시럽 (유료)', '+ Syrup (paid)', '+ Syrup (tính phí)', '+ Сироп (платно)'],
  cafePresetSyrupGroup: ['시럽', 'Syrup', 'Siro', 'Сироп'],
  cafePresetSyrupVanilla: ['바닐라 시럽', 'Vanilla syrup', 'Syrup vanilla', 'Ванильный сироп'],
  cafePresetSyrupCaramel: ['카라멜 시럽', 'Caramel syrup', 'Syrup caramel', 'Карамельный сироп'],
  removeOptionChoice: ['선택지 삭제', 'Remove choice', 'Xóa lựa chọn', 'Удалить вариант'],
  addOptionChoice: ['선택지 추가', 'Add choice', 'Thêm lựa chọn', 'Добавить вариант'],
  addOptionGroup: ['옵션 그룹 추가', 'Add option group', 'Thêm nhóm tùy chọn', 'Добавить группу опций'],
  spiceLevel: ['맵기', 'Spice level', 'Độ cay', 'Острота'],
  spiceNone: ['안매움', 'Not spicy', 'Không cay', 'Не острое'],
  allergens: ['알러지 정보', 'Allergens', 'Thông tin dị ứng', 'Аллергены'],
  allergenPeanut: ['땅콩', 'Peanut', 'Đậu phộng', 'Арахис'],
  allergenShellfish: ['갑각류', 'Shellfish', 'Giáp xác', 'Ракообразные'],
  allergenDairy: ['유제품', 'Dairy', 'Sữa', 'Молочное'],
  allergenEgg: ['계란', 'Egg', 'Trứng', 'Яйцо'],
  allergenSoy: ['대두', 'Soy', 'Đậu nành', 'Соя'],
  allergenWheat: ['밀', 'Wheat', 'Lúa mì', 'Пшеница'],
  allergenFish: ['생선', 'Fish', 'Cá', 'Рыба'],
  allergenNuts: ['견과류', 'Tree nuts', 'Hạt cây', 'Орехи'],
  dietary: ['식단 옵션', 'Dietary options', 'Tuỳ chọn ăn kiêng', 'Диетические опции'],
  vegetarian: ['채식', 'Vegetarian', 'Chay', 'Вегетарианское'],
  vegan: ['비건', 'Vegan', 'Thuần chay', 'Веганское'],
  halal: ['할랄', 'Halal', 'Halal', 'Халяль'],
  unit: ['단위', 'Unit', 'Đơn vị', 'Единица'],
  unitHint: [
    '마트 상품 단위 (개/kg 등)',
    'Product unit (pcs/kg, etc.)',
    'Đơn vị sản phẩm (cái/kg…)',
    'Единица товара (шт/кг…)',
  ],
  unitPiece: ['개', 'pcs', 'cái', 'шт'],
  unitKg: ['kg', 'kg', 'kg', 'кг'],
  unitG: ['g', 'g', 'g', 'г'],
  unitBox: ['박스', 'box', 'hộp', 'коробка'],
  unitSet: ['세트', 'set', 'bộ', 'набор'],
  unitPack: ['팩', 'pack', 'gói', 'упаковка'],
  unitBottle: ['병', 'bottle', 'chai', 'бутылка'],
  soldOut: ['품절', 'Sold out', 'Hết hàng', 'Нет в наличии'],
  soldOutToggle: ['품절 처리', 'Mark as sold out', 'Đánh dấu hết hàng', 'Отметить как нет в наличии'],
  soldOutHint: [
    '켜면 고객 화면에 품절 배지가 보이고 담기가 막혀요',
    'When on, customers see a sold-out badge and cannot add to cart',
    'Khi bật, khách thấy huy hiệu hết hàng và không thêm vào giỏ được',
    'Если включено, клиенты видят значок «нет» и не могут добавить в корзину',
  ],
  inventorySectionTitle: ['재고 관리', 'Inventory', 'Quản lý kho', 'Управление запасами'],
  customerInfoSectionTitle: ['상품 정보', 'Product info', 'Thông tin sản phẩm', 'Информация о товаре'],
  sku: ['SKU 코드', 'SKU code', 'Mã SKU', 'Код SKU'],
  skuPh: ['내부 관리용 코드 (선택)', 'Internal tracking code (optional)', 'Mã quản lý nội bộ (tuỳ chọn)', 'Внутренний код (опционально)'],
  barcode: ['바코드', 'Barcode', 'Mã vạch', 'Штрихкод'],
  barcodePh: [
    '바코드 번호 (EAN/UPC, 선택)',
    'Barcode number (EAN/UPC, optional)',
    'Số mã vạch (EAN/UPC, tuỳ chọn)',
    'Номер штрихкода (EAN/UPC, опционально)',
  ],
  stockQty: ['현재 재고 수량', 'Current stock', 'Số lượng tồn kho', 'Текущий запас'],
  stockQtyHint: [
    '입력하면 재고가 0이 될 때 자동으로 품절 처리돼요',
    'When set, the item is auto-marked sold out at 0 stock',
    'Khi nhập, sản phẩm sẽ tự động hết hàng khi về 0',
    'При заполнении товар автоматически станет «нет в наличии» при 0',
  ],
  safetyStockQty: [
    '안전 재고 (재주문 알림 기준)',
    'Safety stock (reorder alert threshold)',
    'Tồn kho an toàn (ngưỡng cảnh báo đặt lại)',
    'Минимальный запас (порог для напоминания)',
  ],
  safetyStockQtyHint: [
    '이 수량 이하로 떨어지면 알림을 보내드려요',
    "We'll notify you when stock drops to or below this",
    'Chúng tôi sẽ báo khi tồn kho giảm đến mức này',
    'Мы уведомим вас, когда запас упадёт до этого уровня',
  ],
  expiryDate: ['유통기한', 'Expiry date', 'Hạn sử dụng', 'Срок годности'],
  storageType: ['보관 방법', 'Storage', 'Cách bảo quản', 'Хранение'],
  storageRoomTemp: ['실온', 'Room temp', 'Nhiệt độ phòng', 'Комнатная температура'],
  storageRefrigerated: ['냉장', 'Refrigerated', 'Ngăn mát', 'Охлаждённое'],
  storageFrozen: ['냉동', 'Frozen', 'Ngăn đông', 'Замороженное'],
  minOrderQty: ['최소 구매 수량', 'Min order qty', 'SL đặt tối thiểu', 'Мин. количество заказа'],
  maxOrderQty: ['최대 구매 수량', 'Max order qty', 'SL đặt tối đa', 'Макс. количество заказа'],
  maxOrderQtyHint: [
    '라이더가 배달 가능한 무게/부피를 고려해 정해주세요 (선택)',
    'Set based on what a rider can realistically carry (optional)',
    'Đặt dựa trên trọng lượng/khối lượng tài xế có thể chở (tuỳ chọn)',
    'Установите с учётом того, что курьер сможет унести (опционально)',
  ],
  isMarketPrice: ['시가 적용', 'Market price', 'Giá theo thị trường', 'Рыночная цена'],
  isMarketPriceHint: [
    '수산물·제철 상품처럼 매일 가격이 바뀌면 켜주세요 — 가격 대신 "시가"로 표시돼요',
    'Turn on for items whose price changes daily (seafood, seasonal produce) — shows "Market price" instead of a fixed price',
    'Bật cho các mặt hàng thay đổi giá hàng ngày (hải sản, trái cây theo mùa) — hiển thị "Giá thị trường" thay vì giá cố định',
    'Включите для товаров с ежедневно меняющейся ценой (морепродукты, сезонные продукты) — вместо цены покажется «Рыночная цена»',
  ],
  isWeightPriced: ['중량 단위 판매', 'Sell by weight', 'Bán theo trọng lượng', 'Продажа по весу'],
  isWeightPricedHint: [
    '정육·청과처럼 무게로 파는 상품이면 켜주세요',
    'Turn on for items sold by weight (meat, produce)',
    'Bật cho các mặt hàng bán theo trọng lượng (thịt, rau củ)',
    'Включите для товаров, продаваемых на вес (мясо, овощи)',
  ],
  weightPriceBase: ['기준 중량(g)', 'Base weight (g)', 'Trọng lượng cơ sở (g)', 'Базовый вес (г)'],
  weightPricePerBase: [
    '기준 중량당 가격',
    'Price per base weight',
    'Giá theo trọng lượng cơ sở',
    'Цена за базовый вес',
  ],
  weightPriceHint: [
    '예: 기준중량 100g, 가격 30,000동 → "100g당 30,000동"으로 표시돼요',
    'e.g. base 100g, price 30,000₫ → shown as "30,000₫ per 100g"',
    'vd: 100g cơ sở, giá 30.000₫ → hiển thị "30.000₫/100g"',
    'напр. база 100г, цена 30 000₫ → отобразится как «30 000₫ за 100г»',
  ],
  toastPublished: [
    '검수 요청했어요. 승인되면 고객에게 노출돼요.',
    'Submitted for review. It will go live after approval.',
    'Đã gửi duyệt. Sẽ hiện với khách sau khi được duyệt.',
    'Отправлено на проверку. Появится после одобрения.',
  ],
};

const rental = {
  sectionBasic: ['기본 정보', 'Basic info', 'Thông tin cơ bản', 'Основная информация'],
  title: ['상품명 *', 'Product name *', 'Tên sản phẩm *', 'Название товара *'],
  titlePh: [
    '예: 스쿠터 렌탈(자동), 4인승 승용차 렌탈',
    'e.g. Automatic scooter rental, 4-seat car rental',
    'vd: Cho thuê xe tay ga (số tự động), Cho thuê ô tô 4 chỗ',
    'напр. Аренда скутера (автомат), Аренда авто 4 места',
  ],
  desc: ['상품 설명', 'Description', 'Mô tả sản phẩm', 'Описание'],
  descPh: [
    '차량 상태, 대여 조건, 주의사항 등을 입력해주세요.',
    'Describe the vehicle condition, rental terms, and notes.',
    'Nhập tình trạng xe, điều kiện thuê, lưu ý…',
    'Опишите состояние транспорта, условия аренды и детали.',
  ],
  vehicleType: ['차량 종류', 'Vehicle type', 'Loại xe', 'Тип транспорта'],
  transmission: ['변속기', 'Transmission', 'Hộp số', 'Коробка передач'],
  includes: ['포함 사항', 'Included', 'Bao gồm', 'Включено'],
  photos: ['사진', 'Photos', 'Ảnh', 'Фото'],
  sectionPricing: ['요금 정보', 'Pricing', 'Giá cho thuê', 'Стоимость'],
  currency: ['통화', 'Currency', 'Tiền tệ', 'Валюта'],
  dailyPrice: ['1일 요금', 'Daily rate', 'Giá theo ngày', 'Цена за день'],
  weeklyPrice: ['1주 요금', 'Weekly rate', 'Giá theo tuần', 'Цена за неделю'],
  monthlyPrice: ['1달 요금', 'Monthly rate', 'Giá theo tháng', 'Цена за месяц'],
  depositAmount: ['보증금', 'Deposit', 'Tiền đặt cọc', 'Депозит'],
  optionalPh: ['선택 입력', 'Optional', 'Không bắt buộc', 'Необязательно'],
  cancel: ['취소', 'Cancel', 'Hủy', 'Отмена'],
  needTitle: [
    '상품명을 입력해 주세요',
    'Please enter a product name',
    'Vui lòng nhập tên sản phẩm',
    'Введите название товара',
  ],
  needPrice: [
    '1일 요금을 입력해 주세요',
    'Please enter a daily rate',
    'Vui lòng nhập giá theo ngày',
    'Введите цену за день',
  ],
};

const rentalVehicleTypeOptions = {
  car: ['자동차', 'Car', 'Ô tô', 'Автомобиль'],
  motorbike: ['오토바이', 'Motorbike', 'Xe máy', 'Мотобайк'],
  bicycle: ['자전거', 'Bicycle', 'Xe đạp', 'Велосипед'],
  van: ['승합차/밴', 'Van', 'Xe khách/Van', 'Микроавтобус'],
};

const rentalTransmissionOptions = {
  auto: ['자동', 'Automatic', 'Số tự động', 'Автомат'],
  manual: ['수동', 'Manual', 'Số sàn', 'Механика'],
};

const rentalIncludesOptions = {
  helmet: ['헬멧 포함', 'Helmet included', 'Kèm mũ bảo hiểm', 'Шлем включён'],
  insurance: ['보험 포함', 'Insurance included', 'Kèm bảo hiểm', 'Страховка включена'],
  gps: ['GPS 포함', 'GPS included', 'Kèm GPS', 'GPS включён'],
  child_seat: ['카시트 포함', 'Child seat included', 'Kèm ghế trẻ em', 'Детское кресло включено'],
  full_tank: ['연료 완충 제공', 'Full tank provided', 'Đầy bình xăng', 'Полный бак'],
};

const catalogDetailRental = {
  title: ['렌탈 정보', 'Rental info', 'Thông tin cho thuê', 'Информация об аренде'],
  daily: ['1일', 'Daily', 'Theo ngày', 'В день'],
  weekly: ['1주', 'Weekly', 'Theo tuần', 'В неделю'],
  monthly: ['1달', 'Monthly', 'Theo tháng', 'В месяц'],
  includesLabel: ['포함 사항', 'Included', 'Bao gồm', 'Включено'],
  depositNote: [
    '보증금 {amount} (반납 시 환불)',
    'Deposit {amount} (refunded on return)',
    'Đặt cọc {amount} (hoàn trả khi trả xe)',
    'Депозит {amount} (возврат при сдаче)',
  ],
};

const catalogDetailSimPlan = {
  pickTitle: ['요금제 선택', 'Choose a plan', 'Chọn gói', 'Выберите тариф'],
  fromPrice: ['{price}부터', 'From {price}', 'Từ {price}', 'От {price}'],
  validityLabel: ['유효기간', 'Validity', 'Thời hạn', 'Срок действия'],
  dataLabel: ['데이터', 'Data', 'Dung lượng', 'Данные'],
  daysChip: ['{days}일', '{days} days', '{days} ngày', '{days} дней'],
  trustSupport: ['24시간 채팅 문의', '24/7 chat support', 'Hỗ trợ chat 24/7', 'Чат-поддержка 24/7'],
  trustRefund: ['안심 환불 안내', 'Refund guidance', 'Hướng dẫn hoàn tiền', 'Гарантия возврата'],
};

const classForm = {
  sectionBasic: ['기본 정보', 'Basic info', 'Thông tin cơ bản', 'Основная информация'],
  title: ['수업명 *', 'Class name *', 'Tên lớp học *', 'Название урока *'],
  titlePh: [
    '예: 성인 요가 클래스, 초등 미술 수업, 한국어 회화 과외',
    'e.g. Adult yoga class, kids art class, Korean conversation tutoring',
    'vd: Lớp yoga người lớn, lớp vẽ cho trẻ em, gia sư tiếng Hàn',
    'напр. Йога для взрослых, рисование для детей, репетитор корейского',
  ],
  desc: ['수업 설명', 'Description', 'Mô tả lớp học', 'Описание'],
  descPh: [
    '커리큘럼, 준비물, 강사 소개 등을 입력해주세요.',
    'Describe the curriculum, materials needed, instructor background, etc.',
    'Nhập giáo trình, dụng cụ cần chuẩn bị, giới thiệu giáo viên…',
    'Опишите программу, необходимые материалы, информацию о преподавателе.',
  ],
  classType: ['수업 방식', 'Class type', 'Hình thức học', 'Формат занятия'],
  locationType: ['수업 장소', 'Location', 'Địa điểm', 'Место проведения'],
  level: ['난이도', 'Level', 'Trình độ', 'Уровень'],
  scheduleType: ['운영 방식', 'Schedule', 'Lịch học', 'Расписание'],
  instructionLanguage: ['수업 언어', 'Instruction language', 'Ngôn ngữ giảng dạy', 'Язык обучения'],
  materialsIncluded: ['준비물/교재', 'Materials', 'Dụng cụ/giáo trình', 'Материалы'],
  materialsYes: ['교재 포함', 'Materials included', 'Có kèm giáo trình', 'Материалы включены'],
  materialsNo: ['개인 준비', 'Bring your own', 'Tự chuẩn bị', 'Свои материалы'],
  photos: ['사진', 'Photos', 'Ảnh', 'Фото'],
  sectionDetail: ['수업 상세', 'Class details', 'Chi tiết lớp học', 'Детали занятия'],
  ageRange: ['수강 연령 (선택)', 'Age range (optional)', 'Độ tuổi (không bắt buộc)', 'Возраст (необязательно)'],
  minAgePh: ['최소', 'Min', 'Tối thiểu', 'Мин'],
  maxAgePh: ['최대', 'Max', 'Tối đa', 'Макс'],
  maxStudents: ['정원 (1:1은 비워두세요)', 'Class size (leave blank for 1:1)', 'Sĩ số (bỏ trống nếu 1 kèm 1)', 'Размер группы (пусто для 1:1)'],
  maxStudentsPh: ['예: 8', 'e.g. 8', 'vd: 8', 'напр. 8'],
  durationMinutes: ['1회 수업 시간(분)', 'Session length (minutes)', 'Thời lượng 1 buổi (phút)', 'Длительность занятия (мин)'],
  sessionsTotal: ['총 회차 (패키지형인 경우)', 'Total sessions (if package)', 'Tổng số buổi (nếu là gói)', 'Всего занятий (если пакет)'],
  sessionsTotalPh: ['예: 8', 'e.g. 8', 'vd: 8', 'напр. 8'],
  sectionPricing: ['수강료 정보', 'Pricing', 'Học phí', 'Стоимость'],
  currency: ['통화', 'Currency', 'Tiền tệ', 'Валюта'],
  price: ['수강료 *', 'Price *', 'Học phí *', 'Цена *'],
  priceHint: [
    '회차가 있으면 전체 패키지 금액을, 없으면 1회 수업 금액을 입력하세요.',
    'Enter the full package price if sessions are set, otherwise the price per session.',
    'Nếu có tổng số buổi, nhập giá trọn gói; nếu không, nhập giá 1 buổi.',
    'Если указано число занятий — введите цену пакета, иначе — цену за одно занятие.',
  ],
  cancel: ['취소', 'Cancel', 'Hủy', 'Отмена'],
  needTitle: [
    '수업명을 입력해 주세요',
    'Please enter a class name',
    'Vui lòng nhập tên lớp học',
    'Введите название урока',
  ],
  needPrice: [
    '수강료를 입력해 주세요',
    'Please enter a price',
    'Vui lòng nhập học phí',
    'Введите цену',
  ],
};

const classTypeOptions = {
  offline: ['오프라인', 'In-person', 'Trực tiếp', 'Очно'],
  online: ['온라인', 'Online', 'Trực tuyến', 'Онлайн'],
};

const classLocationTypeOptions = {
  studio: ['스튜디오/학원', 'Studio', 'Studio/Trung tâm', 'Студия/центр'],
  home_visit: ['방문 수업', 'Home visit', 'Dạy tại nhà', 'Выезд на дом'],
  online: ['온라인', 'Online', 'Trực tuyến', 'Онлайн'],
};

const classLevelOptions = {
  all: ['전체', 'All levels', 'Mọi trình độ', 'Любой уровень'],
  beginner: ['초급', 'Beginner', 'Sơ cấp', 'Начинающий'],
  intermediate: ['중급', 'Intermediate', 'Trung cấp', 'Средний'],
  advanced: ['고급', 'Advanced', 'Nâng cao', 'Продвинутый'],
};

const classScheduleTypeOptions = {
  fixed: ['정규 기수제', 'Fixed cohort', 'Theo khóa cố định', 'Фиксированный поток'],
  flexible: ['자유 예약제', 'Flexible booking', 'Đặt lịch linh hoạt', 'Гибкое бронирование'],
};

const catalogDetailClass = {
  title: ['수업 정보', 'Class info', 'Thông tin lớp học', 'Информация о занятии'],
  levelLabel: ['난이도', 'Level', 'Trình độ', 'Уровень'],
  durationLabel: ['수업 시간', 'Duration', 'Thời lượng', 'Длительность'],
  durationValue: ['{minutes}분', '{minutes} min', '{minutes} phút', '{minutes} мин'],
  sessionsLabel: ['총 회차', 'Sessions', 'Tổng số buổi', 'Занятий'],
  sessionsValue: ['{count}회', '{count} sessions', '{count} buổi', '{count} занятий'],
  capacityLabel: ['정원', 'Class size', 'Sĩ số', 'Размер группы'],
  capacityValue: ['최대 {count}명', 'Up to {count}', 'Tối đa {count} người', 'До {count} чел.'],
  capacityOneToOne: ['1:1 개인수업', '1-on-1', '1 kèm 1', 'Индивидуально'],
  ageLabel: ['수강 연령', 'Age range', 'Độ tuổi', 'Возраст'],
  ageValue: ['{min}~{max}세', 'Ages {min}-{max}', '{min}-{max} tuổi', '{min}-{max} лет'],
  materialsIncludedBadge: ['교재 포함', 'Materials included', 'Kèm giáo trình', 'Материалы включены'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    // service.timeDiscount/combo처럼 중첩 객체(문자열 튜플이 아닌)가 섞여있을 수 있어서 재귀 처리한다.
    if (Array.isArray(v)) {
      out[k] = v[langIndex];
    } else if (v && typeof v === 'object') {
      out[k] = pick(v, langIndex);
    } else {
      out[k] = v;
    }
  });
  return out;
}

function buildLang(langIndex) {
  return {
    catalogForm: {
      common: pick(common, langIndex),
      package: {
        ...pick(pkgShell, langIndex),
        steps: pick(pkgSteps, langIndex),
        options: pick(pkgOptions, langIndex),
        basic: pick(pkgBasic, langIndex),
        pricing: pick(pkgPricing, langIndex),
        finish: pick(pkgFinish, langIndex),
        terms: pick(pkgTerms, langIndex),
        itin: pick(pkgItin, langIndex),
        services: pick(pkgServices, langIndex),
        servicesUi: pick(pkgServicesUi, langIndex),
        ie: pick(pkgIe, langIndex),
        owner: pick(pkgOwner, langIndex),
      },
      tour: pick(tour, langIndex),
      accommodation: pick(accommodation, langIndex),
      service: pick(service, langIndex),
      menu: pick(menu, langIndex),
      simPlan: {
        ...pick(simPlan, langIndex),
        simFormOptions: pick(simFormOptions, langIndex),
        deliveryOptions: pick(deliveryOptions, langIndex),
      },
      rental: {
        ...pick(rental, langIndex),
        vehicleTypeOptions: pick(rentalVehicleTypeOptions, langIndex),
        transmissionOptions: pick(rentalTransmissionOptions, langIndex),
        includesOptions: pick(rentalIncludesOptions, langIndex),
      },
      class: {
        ...pick(classForm, langIndex),
        classTypeOptions: pick(classTypeOptions, langIndex),
        locationTypeOptions: pick(classLocationTypeOptions, langIndex),
        levelOptions: pick(classLevelOptions, langIndex),
        scheduleTypeOptions: pick(classScheduleTypeOptions, langIndex),
      },
    },
    catalogDetail: {
      simPlan: pick(catalogDetailSimPlan, langIndex),
      rental: pick(catalogDetailRental, langIndex),
      class: pick(catalogDetailClass, langIndex),
    },
  };
}

export const phaseP0CatalogKo = buildLang(0);
export const phaseP0CatalogEn = buildLang(1);
export const phaseP0CatalogVi = buildLang(2);
export const phaseP0CatalogRu = buildLang(3);

/** Resolve chip option label via i18n key + optional labelParams. */
export function optionLabel(opt, t) {
  if (opt?.labelKey && t) {
    const translated = t(opt.labelKey, opt.labelParams || {});
    if (translated && translated !== opt.labelKey) return translated;
  }
  return opt?.label;
}
